export default {
    id: "আইডি",
    dashboard: "ড্যাশবোর্ড",
    warning: "সতর্কতা",
    users: "ব্যবহারকারীদের",
    farms: "খামার",
    animals: "প্রাণী",
    action: "কর্ম",
    actionList: "কার্য তালিকা",
    drugInventory: "ড্রাগ ইনভেন্টরি",
    inseminatorStatistics: "ইনসেমিনেটর পরিসংখ্যান",
    organizationNTR: "সংগঠন NTR",
    genotypePerformance: "জিনোটাইপ কর্মক্ষমতা",
    semenAutomation: "বীর্য অটোমেশন",
    activityLogs: "কার্য বিবরণ",
    username: "ব্যবহারকারীর নাম",
    title: "শিরোনাম",
    deactivated: "নিষ্ক্রিয়",
    name: "নাম",
    email: "ইমেইল",
    emailAddress: "ইমেইল ঠিকানা",
    mobileNum: "মোবাইল নম্বর",
    emailOrMobile: "ইমেইল/মোবাইল",
    role: "ভূমিকা",
    roles: "ভূমিকা",
    department: "বিভাগ",
    status: "স্ট্যাটাস",
    pages: "পাতা",
    departments: "বিভাগসমূহ",
    password: "পাসওয়ার্ড",
    cancel: "বাতিল করুন",
    submit: "জমা দিন",
    error: "ত্রুটি",
    success: "সাফল্য",
    Browse: "ব্রাউজ করুন",
    orDropYourFileCsvXlsXlsxHere: "অথবা আপনার ফাইল (CSV, XLS, XLSx) এখানে ড্রপ করুন",
    search: "অনুসন্ধান করুন",
    apply: "আবেদন করুন",
    select: "নির্বাচন করুন",
    previous: "আগে",
    mandatory: "বাধ্যতামূলক",
    dropYourFileHere: "অথবা আপনার ফাইল (CSV, XLS, XLSx, PDF,Docx, PNG, JPEG) এখানে ড্রপ করুন",
    restoreDefault: "সাধারনে প্রত্যাবর্তন",
    pending: "বিচারাধীন",
    completed: "সম্পন্ন",
    remove: "অপসারণ",
    update: "হালনাগাদ",
    removeFile: "ফাইল সরান",
    uploadFile: "ফাইল আপলোড করুন",
    pleaseChoosePreferedLanguage: "আপনার পছন্দের ভাষা চয়ন করুন",
    edit: "সম্পাদনা করুন",
    activate: "সক্রিয় করুন",
    deactivate: "নিষ্ক্রিয় করুন",
    recievedOrders: "প্রাপ্ত আদেশ",
    chartRepresentation: "চার্ট প্রতিনিধিত্ব",
    nameIsRequired: "নাম আবশ্যক",
    export: "রপ্তানি",
    noFilesAvailable: "কোন ফাইল উপলব্ধ নেই",
    selectDepartmentToshowRoles: "ভূমিকা দেখানোর জন্য একটি বিভাগ নির্বাচন করুন",
    selectDepartmentWithActiveRoles: "সক্রিয় ভূমিকা সহ একটি বিভাগ নির্বাচন করুন",
    nameCanContainOnlyAlphabets: "নামের শুধুমাত্র বর্ণমালা থাকতে পারে",
    nameMustBeLessThan15Chars: "নাম অবশ্যই 30 অক্ষরের কম হতে হবে",
    emailRequired: "ইমেল প্রয়োজন",
    invalidEmailFormat: "অবৈধ ইমেল বিন্যাস",
    mobNumReq: "মোবাইল নম্বর প্রয়োজন",
    invalidMobFormat: "অবৈধ মোবাইল নম্বর বিন্যাস.",
    passwordRequired: "পাসওয়ার্ড প্রয়োজন",
    departmentReq: "বিভাগ প্রয়োজন",
    roleReq: "ভূমিকা প্রয়োজন",
    unableToUpdate: "আপডেট করতে অক্ষম",
    orignalName: "আসল নাম",
    uploadedDate: "আপলোডের তারিখ",
    fileName: "ফাইলের নাম",
    importNum: "আমদানি নম্বর",
    languagePreferences: "ভাষা পছন্দ",
    pleaseTryAgainAfterSometime: "কিছু সময় পরে চেষ্টা করুন",
    noChanges: "কোন পরিবর্তন নেই",
    nothingchanged: "কিছুই বদলায়নি",
    pleaseChooseAnImageFile: "একটি ইমেজ ফাইল চয়ন করুন",
    fileIsTooBigSelectUnder1MB: "আপনার ফাইল অনেক বড়! ",
    phoneShouldHave10Chars: "ফোনে 10টি অক্ষর থাকা উচিত",
    onlyCSVAllowed: "শুধুমাত্র CSV ফাইল অনুমোদিত",
    loadingPleaseWait: "প্রেরণ করা হচ্ছে, অনুগ্রহ করে অপেক্ষা করুন",
    manager: "ম্যানেজার",
    administrator: "প্রশাসক",
    Comingsoon: "শীঘ্রই আসছে",
    totalAnimals: "মোট প্রাণী",
    receivedOrders: "গৃহীত আদেশ",
    drugs: "ওষুধের",
    detailedAnalysis: "বিস্তারিত বিশ্লেষণ",
    barGraphRepOfActiveUsersAndDeactivateUsers: "সক্রিয় ব্যবহারকারী এবং নিষ্ক্রিয় ব্যবহারকারীদের বার গ্রাফ প্রতিনিধিত্ব",
    barGraphRepOfRegAnimalsVsFarm: "নিবন্ধিত প্রাণী বনাম খামারের বার গ্রাফ প্রতিনিধিত্ব",
    roleNumber: "ভূমিকা নম্বর",
    roleName: "নামভূমিকা",
    active: "সক্রিয়",
    inactive: "নিষ্ক্রিয়",
    admin: "অ্যাডমিন",
    addRole: "ভূমিকা যোগ করুন",
    addRoles: "ভূমিকা যোগ করুন",
    permissions: "অনুমতি",
    sr: "সিনিয়র",
    moduleName: "মডিউল নাম",
    view: "দেখুন",
    deptNo: "বিভাগ নং",
    selectByCategory: "বিভাগ অনুসারে নির্বাচন করুন",
    weeklyAnalytics: "সাপ্তাহিক বিশ্লেষণ",
    pregnancy: "গর্ভাবস্থা",
    analytics: "বিশ্লেষণ",
    calendar: "ক্যালেন্ডার",
    productName: "পণ্যের নাম",
    volumeSold: "ভলিউম বিক্রি",
    recordPoints: "রেকর্ড পয়েন্ট",
    inStock: "স্টকে",
    revenue: "রাজস্ব",
    stockStatus: "স্টক অবস্থা",
    barChart: "বার চার্ট",
    lineChart: "লাইন চার্ট",
    indexReturns: "ইনডেক্স রিটার্ন",
    chart: "চার্ট",
    time: "সময়",
    production: "উৎপাদন",
    customization: "কাস্টমাইজেশন",
    recordsPerPage: "পৃষ্ঠা প্রতি রেকর্ড",
    noDataAvailable: "কোন তথ্য নেই",
    reporting: "রিপোর্টিং",
    optional: "ঐচ্ছিক",
    note: "বিঃদ্রঃ",
    notes: "মন্তব্য",
    date: "তারিখ",
    kG: "কেজি",
    weight: "ওজন",
    type: "টাইপ",
    lessthan3Month: "<3 মাস",
    lessthan6Month: "<6 মাস",
    lessthan7Month: "<7 মাস",
    lastWeek: "গত সপ্তাহে",
    thisWeek: "এই সপ্তাহ",
    lessthanOneYear: "<1 বছর",
    lessthanTwoYear: "<2 বছর",
    lessthanThreeYear: "<3 বছর",
    lessthanFourYear: "<4 বছর",
    yes: "হ্যাঁ",
    no: "না",
    of: "এর",
    notSpecified: "উল্লিখিত না",
    days: "দিন",
    day: "দিন",
    aDay: "এক দিন",
    years: "বছর",
    year: "বছর",
    unit: "ইউনিট",
    units: "ইউনিট",
    to: "প্রতি",
    profile: "প্রোফাইল",
    logOut: "প্রস্থান",
    Unit: "ইউনিট",
    otherSettings: "অন্যান্য সেটিংস্",
    somethingWentWrong: "কিছু ভুল হয়েছে.",
    toDo: "করতে",
    loadingData: "তথ্য প্রস্তুত হচ্ছে...",
    taskNumber: "টাস্ক নম্বর",
    taskName: "টাস্কের নাম",
    startDate: "শুরুর তারিখ",
    dueDate: "নির্দিষ্ট তারিখ",
    reason: "কারণ",
    quantity: "পরিমাণ",
    cost: "খরচ",
    noRecordFound: "পাওয়া কোন রেকর্ড",
    dailyUpdates: "দৈনিক আপডেট",
    weeklyUpdates: "সাপ্তাহিক আপডেট",
    moduleAccessed: "মডিউল অ্যাক্সেস করা হয়েছে",
    typesOfAccess: "অ্যাক্সেসের ধরন",
    userId: "ব্যবহারকারী আইডি",
    lastLogin: "শেষ লগইন",
    terminalID: "টার্মিনাল আইডি",
    geographicalAccessPoint: "ভৌগলিক অ্যাক্সেস পয়েন্ট",
    iPAddress: "আইপি ঠিকানা",
    fileAccessed: "ফাইল অ্যাক্সেস করা হয়েছে",
    functionAccessed: "ফাংশন অ্যাক্সেস করা হয়েছে",
    webPageURL: "ওয়েব পৃষ্ঠা URL",
    accessType: "অ্যাক্সেসের ধরন",
    unsuccessfulLoginAttempts: "ব্যর্থ লগইন প্রচেষ্টা",
    customerAddress: "গ্রাহকের ঠিকানা",
    orderdate: "অর্ডারের তারিখ",
    postageDate: "ডাক তারিখ",
    postID: "পোস্ট আইডি",
    packingTechnician: "প্যাকিং টেকনিশিয়ান",
    packingTechnicia: "প্যাকিং টেকনিশিয়া",
    packEdit: "প্যাক সম্পাদনা করুন",
    batchNumber: "ব্যাচ নাম্বার",
    collectionTechnician: "কালেকশন টেকনিশিয়ান",
    collectionTechnicia: "সংগ্রহ প্রযুক্তি",
    preparationTechnicia: "প্রিপারেশন টেকনিশিয়া",
    preparationTechnician: "প্রিপারেশন টেকনিশিয়ান",
    approvedManually: "ম্যানুয়ালি অনুমোদিত",
    researcher: "গবেষক",
    dateOfApproval: "অনুমোদনের তারিখ",
    approvalEdit: "অনুমোদন সম্পাদনা",
    searchByAllExceptDate: "তারিখ ছাড়া সকল দ্বারা অনুসন্ধান করুন",
    approval: "অনুমোদন",
    collection: "সংগ্রহ",
    postage: "ডাক",
    pack: "প্যাক",
    straws: "খড়",
    createdAt: "এ নির্মিত",
    sireID: "স্যার আইডি",
    economicIndexValue: "অর্থনৈতিক সূচক মান",
    latestCollectionDate: "সর্বশেষ সংগ্রহের তারিখ",
    locationId: "অবস্থান আইডি",
    lastUpdated: "সর্বশেষ সংষ্করণ",
    print: "ছাপা",
    save: "সংরক্ষণ",
    tax: "ট্যাক্স",
    phoneNo: "ফোন নম্বর",
    exportAsPDF: "পিডিএফ হিসাবে রপ্তানি করুন",
    statusUpdated: "স্থিতি আপডেট করা হয়েছে",
    statusNotUpdated: "স্থিতি আপডেট করা হয়নি",
    inProgress: "চলমান",
    assignedTo: "নির্ধারিত",
    taskId: "টাস্ক আইডি",
    createdDate: "তৈরীর তারিখ",
    numberOfAnimals: "প্রাণীর সংখ্যা",
    healthRecordSubmittedSuccess: "স্বাস্থ্য রেকর্ড সফলভাবে জমা দেওয়া হয়েছে",
    healthRecordSubmitted: "স্বাস্থ্য রেকর্ড জমা।",
    InseminationRecordSubmittedSuccesful: "গর্ভধারণের রেকর্ড সফলভাবে জমা দেওয়া হয়েছে",
    inseminationRecordSubmitted: "গর্ভধারণের রেকর্ড জমা দেওয়া হয়েছে।",
    actionListDailyTask: "কর্ম তালিকা - দৈনিক কাজ",
    sinceLastYear: "গত বছর থেকে",
    sinceLastQuarter: "গত কোয়ার্টার থেকে",
    sinceLastMonth: "গত মাস থেকে",
    sinceLastWeek: "গত সপ্তাহ থেকে",
    drugWithdrawPeriod: "ড্রাগ প্রত্যাহার সময়কাল",
    diagnosisName: "রোগ নির্ণয়ের নাম",
    animalWithNoGenetype: "এই প্রাণীর কোনো জিনোটাইপ ডেটা নিবন্ধিত নেই। ",
    nameOfPreviousOwner: "পূর্ববর্তী মালিকের নাম",
    avatarSize: "অবতারের আকার 1 MB এর কম হওয়া উচিত!",
    testDestination: "পরীক্ষার গন্তব্য",
    animalNotAdded: "পশু যোগ করা হয়নি",
    registerationSuccessful: "অস্ত্রোপচার",
    backToAnimalList: "প্রাণী তালিকায় ফিরে যান",
    addAnotherAnimal: "আরেকটি প্রাণী যোগ করুন",
    animalDetailsUpdated: "পশুর বিবরণ সফলভাবে আপডেট করা হয়েছে",
    animalUpdatedSuccessfully: "পশু সফলভাবে আপডেট করা হয়েছে",
    animalNotUpdated: "প্রাণী আপডেট করা হয়নি",
    notMember: "না একটি সদস্য?",
    requestAccess: "অনুরোধ এক্সেস",
    typePassword: "পাসওয়ার্ড টাইপ করুন.",
    minChars: "নূন্যতম 6 অক্ষর",
    typeConfirmPassword: "কনফার্ম পাসওয়ার্ড টাইপ করুন",
    passConfig: "পাসওয়ার্ড নিশ্চিতকরণ মেলে না.",
    invalidEmailMobile: "অবৈধ ইমেল/মোবাইল বিন্যাস",
    passwordNotEmpty: "পাসওয়ার্ড খালি করা যাবে না",
    passwordLength: "পাসওয়ার্ডের দৈর্ঘ্য 8 অক্ষরের কম হতে পারে না",
    cityVillage: "শহর/গ্রাম",
    districtRegion: "জেলা/অঞ্চল",
    alreadyHaveAnAccount: "ইতিমধ্যে একটি অ্যাকাউন্ট আছে?",
    genetypeUpdated: "জিনোটাইপ আপডেট করা হয়েছে",
    genetypeNotUpdated: "জিনোটাইপ আপডেট করা হয়নি",
    sellTrade: "বিক্রয়/বাণিজ্য",
    milkingDevon: "মিল্কিং ডেভন প্রজনন স্টক বিক্রয়ের জন্য",
    detailedDescription: "বিস্তারিত বিবরণ",
    longPara: "আমেরিকান মিল্কিং ডেভন ষাঁড়ের গাভী এবং গরু। ",
    contactSeller: "বিক্রেতার সাথে যোগাযোগ করুন",
    enterListingTitle: "তালিকার শিরোনাম লিখুন",
    livestocktype: "পশুসম্পদ প্রকার",
    uploadImage: "একটি ছবি আপলোড করুন",
    mobilePhone: "মোবাইল ফোন নম্বর",
    myLivestock: "আমার পশুসম্পদ",
    livestockObservations: "পশুসম্পদ পর্যবেক্ষণ",
    selectFromRegisteredAnimals: "নিবন্ধিত প্রাণীর তালিকা থেকে নির্বাচন করুন",
    selectOption: "বিকল্প নির্বাচন",
    selectTypeObservation: "পর্যবেক্ষণের ধরন নির্বাচন করুন",
    attachVeteinaryDocument: "ভেটেরিনারি ডকুমেন্ট সংযুক্ত করুন",
    addsensorReading: "সেন্সর রিডিং যোগ করুন",
    myDocument: "আমার ডকুমেন্টস",
    enterAKeyword: "একটি শব্দ লিখুন",
    documentType: "নথিপত্র ধরণ",
    registerEditLivestock: "পশুসম্পদ নিবন্ধন/সম্পাদনা করুন",
    editLivestockProfile: "পশুসম্পদ প্রোফাইল সম্পাদনা করুন",
    copy: "কপি",
    dateOfRegister: "নিবন্ধনের তারিখ",
    livestockType: "পশুসম্পদ প্রকার",
    registerNewLivestock: "নতুন প্রাণিসম্পদ নিবন্ধন",
    enterUniqueTag: "ইউনিক ট্যাগ লিখুন",
    color: "রঙ",
    gender: "লিঙ্গ",
    male: "পুরুষ",
    female: "মহিলা",
    damm: "বাঁধ",
    siree: "স্যার",
    dateOfSaleAuction: "বিক্রয়/নিলাম বিক্রয়ের তারিখ",
    auctionRecord: "মৃত্যুর তালিকার নিলাম রেকর্ড",
    distinguishingFeatures: "বিশিষ্ট বৈশিষ্ট্য",
    keywordListing: "কীওয়ার্ড বা তালিকা আইডি",
    adType: "বিজ্ঞাপনের ধরন",
    activeListingFund: "1 সক্রিয় তালিকা পাওয়া গেছে",
    setupSensors: "সেন্সর সেট আপ করুন",
    serialNumber: "ক্রমিক সংখ্যা",
    sensorLocation: "সেন্সর অবস্থান",
    sensorType: "সেন্সর প্রকার",
    installationDate: "ইনস্টলেশনের তারিখ",
    ExpirationDate: "মেয়াদ শেষ হওয়ার তারিখ",
    addGeo: "ভূ-অবস্থান যোগ করুন",
    addMoreSensors: "আরো সেন্সর যোগ করুন",
    trackAndTrace: "ট্র্যাক এবং ট্রেস",
    createNewShipment: "একটি নতুন চালান তৈরি করুন",
    workflowReference: "ওয়ার্কফ্লো রেফারেন্স",
    invoiceDate: "চালান তারিখ",
    trackShipment: "ট্রাকে পরিবহন করা",
    totalShipments: "মোট চালান",
    activeShipment: "সক্রিয় চালান",
    completedObjectives: "উদ্দেশ্য সম্পন্ন",
    processedPayments: "প্রসেসড পেমেন্ট",
    pointOfDestination: "পয়েন্ট অফ ডেস্টিনেশন",
    sellerInformation: "বিক্রেতার তথ্য",
    selectSellerConsignor: "বিক্রেতা/প্রেরক নির্বাচন করুন",
    pointOfOrigin: "মূল বিন্দু",
    buyerInfo: "ক্রেতার তথ্য",
    selectBuyerConsignor: "ক্রেতা/প্রেরক নির্বাচন করুন",
    addSensorTriggers: "সেন্সর ট্রিগার যোগ করুন",
    processPayments: "প্রসেস পেমেন্ট",
    defineShippingContract: "শিপিং চুক্তি সংজ্ঞায়িত করুন",
    addDigitize: "যোগ করুন",
    currentlyOnFarm: "বর্তমানে খামারে",
    addSire: "স্যার যোগ করুন",
    addApproval: "অনুমোদন যোগ করুন",
    addCollection: "সংগ্রহ যোগ করুন",
    addStraws: "খড় যোগ করুন",
    addPack: "প্যাক যোগ করুন",
    addPostage: "ডাক যোগ করুন",
    searchBySire: "স্যার দ্বারা অনুসন্ধান করুন",
    anyDataChangeMightBeLost: "কোনো তথ্য পরিবর্তন হারিয়ে যেতে পারে",
    wouldYouLikeToSaveOrWantToLeaveWithoutSaving: "আপনি কি সংরক্ষণ করতে চান নাকি সংরক্ষণ না করে চলে যেতে চান",
    leave: "ছেড়ে দিন",
    stay: "থাকা",
    animalFarm: "পশু খামার",
    animalFarmH: "পশু খামার",
    animalOrigin: "প্রাণীর উৎপত্তি",
    animalOriginH: "প্রাণীর উৎপত্তি",
    farmOfOrigin: "ফার্ম অফ অরিজিন",
    farmOfOriginH: "ফার্ম অফ অরিজিন",
    selectFarm: "খামার নির্বাচন করুন",
    searchFarm: "খামার অনুসন্ধান করুন",
    confirmation: "নিশ্চিতকরণ",
    proceed: "এগিয়ে যান",
    ok: "ঠিক আছে",
    animal: {
      tagH: "ট্যাগ",
      tagNumberH: "ট্যাগ নম্বর: আপনি রঙের পাশাপাশি নম্বর যোগ করতে পারেন। ",
      goveRegNoH: "সনাক্তকরণের বিবরণ যাতে ব্যক্তির নাম এবং ঠিকানা, প্রক্রিয়াটির পরিষেবার জন্য ব্যক্তির এজেন্ট, সম্পাদিত কার্যকলাপের অবস্থান এবং ব্যক্তি যে পরিষেবা প্রদান করে তার বিবরণ অন্তর্ভুক্ত থাকতে পারে।",
      birthWeightH: "বাছুরের জন্মের ওজন",
      birthEaseH: "গবাদি পশুর জন্ম একটি প্রাকৃতিক প্রক্রিয়া কিন্তু কখনও কখনও এমন জন্মগত সমস্যা হতে পারে যেখানে বাঁধের জন্য কৃষক/যাজকদের সাহায্যের প্রয়োজন হয়।",
      birthFarmH: "পশুর উৎপত্তি/জন্মের খামার।",
      surrogateDamH: "স্ত্রী গাভীর আইডি যেখানে একজন দাতা পুরুষ এবং দাতা মহিলা থেকে নিষিক্ত ডিম তার আরও বিকাশের জন্য রোপণ করা হয়।",
      ownerH: "এটি পশুর মালিকের নাম।",
      damH: "পশুর মহিলা পিতা/মাতার আইডি।",
      sireH: "পশুর পুরুষ পিতা/মাতার আইডি।",
      breedH: "একটি জাত হল একজাতীয় চেহারা (ফেনোটাইপ), সমজাতীয় আচরণ এবং/অথবা অন্যান্য বৈশিষ্ট্য যা একই প্রজাতির অন্যান্য জীব থেকে আলাদা করে এমন গৃহপালিত প্রাণীদের একটি নির্দিষ্ট গোষ্ঠী।",
      conceptionMethodH: "কিভাবে প্রাণীটি গর্ভধারণ করা হয়েছিল।",
      genderH: "প্রাণীর লিঙ্গ।",
      dobH: "প্রাণীর জন্ম তারিখ।",
      operatorH: "এই প্রাণীর তথ্য পূরণকারী ব্যক্তির নাম।",
      removalFarmH: "পশু অপসারণ খামার ",
      dateOfRemovalH: "পশু অপসারণের তারিখ",
      destinationOfRemoval: "অপসারিত পশুর গন্তব্য স্থান",
      reasonOfRemovalH: "পশু অপসারণের কারণ",
      trackingNumberH: "পশু অপসারণ করা হলে পশুর জন্য নির্ধারিত নম্বর",
      brandH: "ব্র্যান্ড- সহজভাবে একটি স্থায়ী চিহ্ন যা গরুর গায়ে পোড়ানো হয়েছিল।",
      tattoH: "পশুর উপর ট্যাটু।",
      hornStatusH: "পশুর শিং আছে কিনা।",
      animalOriginH: "প্রাণীর উৎপত্তির দেশ।",
      previousOwnerH: "প্রাপ্তবয়স্ক হলে পশুর আগের মালিকের নাম।",
      twinH: "এই ক্ষেত্র বলে যে প্রাণীটির যমজ আছে কি না।",
      regBreedAssoNoH: "ব্রিড অ্যাসোসিয়েশন/সোসাইটিগুলির সাথে নিবন্ধন।",
      breedAssoNameH: "অ্যাসোসিয়েশন/সোসাইটির নাম যেখানে প্রাণীটি নিবন্ধিত হয়েছিল",
      breederH: "পশু সরবরাহকারী সংস্থার নাম এটি।",
      breeder: "ব্রিডার",
      noteH: "প্রাণী সম্পর্কে গুরুত্বপূর্ণ নোট(গুলি)।",
      accuracyWeight_for_field: "সঠিকতা ওজন",
      conception: "ধারণা",
      addAnAnimal: "একটি প্রাণী যোগ করুন",
      addAnimal: "পশু যোগ করুন",
      registerAnAnimal: "একটি প্রাণী নিবন্ধন",
      uploadAnAnimal: "একটি প্রাণী আপলোড করুন",
      animalRegistration: "পশু নিবন্ধন",
      animalDetails: "প্রাণীর বিবরণ",
      tag: "ট্যাগ",
      tagNumber: "ট্যাগ সংখ্যা",
      govtRegNumber: "সরকার ",
      birthWeight: "জন্মের ওজন",
      birthEase: "জন্ম সহজ",
      birthFarm: "জন্ম খামার",
      surrogateDam: "সারোগেট বাঁধ",
      owner: "মালিক",
      ownershipType: "মালিকানার ধরন",
      animalDiseaseRecord: "পশু রোগের রেকর্ড",
      govtReg: "সরকার ",
      regDate: "রেজিঃ তারিখ",
      dam: "বাঁধ",
      sire: "স্যার",
      heifer: "হেইফার",
      steer: "হাল ধরা",
      calf: "বাছুর",
      farmHerd: "খামার/পাল",
      femaleCalf: "স্ত্রী বাছুর",
      maleCalf: "পুরুষ বাছুর",
      newCalves: "নতুন বাছুর",
      breed: "বংশবৃদ্ধি",
      conceptionMethod: "ধারণা পদ্ধতি",
      gender: "লিঙ্গ",
      dateOfBirth: "জন্ম তারিখ",
      operator: "অপারেটর",
      animalRemovedFarm: "পশু অপসারণ খামার",
      dateOfAnimalRemoval: "পশু অপসারণের তারিখ",
      destinationOfRemovedAnimal: "সরানো প্রাণীর গন্তব্য",
      reasonOfRemoval: "অপসারণের কারণ",
      optionalAnimalInformation: "ঐচ্ছিক প্রাণী তথ্য",
      animalPicture: "পশুর ছবি",
      trackingNumber: "ট্র্যাকিং নম্বর",
      brand: "ব্র্যান্ড",
      tatto: "ট্যাটু",
      hornStatus: "হর্ন স্ট্যাটাস",
      animalOrigin: "প্রাণীর উৎপত্তি",
      previosOwner: "পূর্ববর্তী মালিক",
      twin: "যমজ",
      InABreedAssociation: "রেজি.",
      nameOfBreedAssociations: "জাত সংঘের নাম",
      breedAssociations: "জাত সংঘ",
      breederSupplier: "ব্রিডার (সরবরাহকারী)",
      importAnimal: "পশু আমদানি করুন",
      loadingAnimals: "প্রাণী লোড হচ্ছে... অনুগ্রহ করে অপেক্ষা করুন",
      totalRegAnimals: "মোট রেজি. ",
      totalPregnantAnimals: "মোট গর্ভবতী প্রাণী",
      pregnantAnimalHistory: "গর্ভবতী প্রাণীর ইতিহাস",
      dailyAnimalPregnancyUpdates: "দৈনিক পশু গর্ভাবস্থা আপডেট",
      animalHistory: "প্রাণীর ইতিহাস",
      dailyAnimalUpdates: "দৈনিক পশু আপডেট",
      totalPregnant: "মোট গর্ভবতী",
      totalNewBorn: "টোটাল নিউ বর্ন",
      searchByIDGOVRegTag: "আইডি, জিওভি রেজি এবং ট্যাগ দ্বারা অনুসন্ধান করুন",
      noANIMALAVAILABLE: "কোন প্রাণী উপলব্ধ",
      associationNumber: "অ্যাসোসিয়েশন নম্বর",
      associationName: "সমিতির নাম",
      destinationName: "গন্তব্যের নাম",
      plastic: "প্লাস্টিক",
      metal: "ধাতু",
      naturalMating: "প্রাকৃতিক মিলন",
      artificialInsemination: "কৃত্রিম প্রজনন",
      embryoTransfer: "ভ্রূণ স্থানান্তর",
      noAssistance: "কোন সাহায্য নেই",
      someAssistance: "কিছু সহায়তা",
      mechanicalAssistance: "যান্ত্রিক সহায়তা",
      aCesareanSection: "একটি সিজারিয়ান বিভাগ",
      abnormalDelivery: "অস্বাভাবিক ডেলিভারি",
      male: "পুরুষ",
      female: "মহিলা",
      sale: "বিক্রয়",
      slaughter: "বধ",
      death: "মৃত্যু",
      theft: "চুরি",
      other: "অন্যান্য",
      horned: "শিংওয়ালা",
      polled: "পোলড",
      dehorned: "Dehorned",
      details: "বিস্তারিত",
      performance: "কর্মক্ষমতা",
      geneticWorth: "জেনেটিক ওয়ার্থ",
      healthRecord: "স্বাস্থ্য রেকর্ড",
      genotypeData: "জিনোটাইপ ডেটা",
      reminders: "অনুস্মারক",
      activityLog: "কার্য বিবরণ",
      activityLogDetails: "কার্যকলাপ লগ বিবরণ",
      editAnimal: "প্রাণী সম্পাদনা করুন",
      familyInfo: "পারিবারিক তথ্য",
      breedInfo: "জাত তথ্য",
      identification: "শনাক্তকরণ",
      removalInfo: "অপসারণ তথ্য",
      iDOfAnimalDam: "পশুর বাঁধের আইডি।",
      iDOfAnimalSire: "পশুর স্যারের আইডি।",
      iDOfDamEmbryoUsed: "বাঁধের আইডি যার ভ্রূণ ব্যবহার করা হয়েছিল।",
      animalHasATwinOrNot: "প্রাণীটির যমজ আছে কি না।",
      breedType: "জাত প্রকার",
      breedOfTheAnimal: "এটি প্রাণীর একটি জাত।",
      regBreedAssociations: "ব্রিড অ্যাসোসিয়েশন / সমিতির সাথে নিবন্ধন।",
      nameOfAssociationsSocieties: "অ্যাসোসিয়েশন/সোসাইটির নাম যেখানে প্রাণীটি নিবন্ধিত হয়েছিল।",
      nameOfTheOrgSuppliedAnimal: "পশু সরবরাহকারী সংস্থার নাম এটি।",
      countryOriginAnimal: "প্রাণীর উৎপত্তির দেশ।",
      birthFarmID: "জন্ম খামার আইডি",
      farmIDAnimalBorn: "ফার্ম আইডি যেখানে পশুর জন্ম হয়েছে।",
      currentOwner: "বর্তমান মালিক",
      nameOfOwnerAnimal: "এটি পশুর মালিকের নাম।",
      registrationDate: "নিবন্ধনের তারিখ",
      previousOwner: "পূর্বতন মালিক",
      nameOfOperator: "অপারেটরের নাম",
      dateAnimalRemoved: "পশু অপসারণের তারিখ।",
      destinationPlaceRemovedAnimal: "অপসারিত পশু জন্য গন্তব্য স্থান",
      namePersonFillAnimalInformation: "এই প্রাণীর তথ্য পূরণকারী ব্যক্তির নাম।",
      reasonOfAnimalRemoval: "পশু অপসারণের কারণ",
      reasonWhyTheAnimalIsRemoved: "কেন পশু অপসারণ করা হয়",
      processingDate: "প্রক্রিয়াকরণের তারিখ",
      DateInformationFilledChanged: "যে তারিখে বর্তমান তথ্য পূরণ করা হয়েছে বা পরিবর্তন করা হয়েছে।",
      animalID: "প্রাণী আইডি",
      UniqueIdAnimal: "এটি প্রাণীর অনন্য আইডি।",
      plasticTagNumber: "প্লাস্টিক ট্যাগ নম্বর",
      numberAnimalTag: "প্রাণী ট্যাগের সংখ্যা।",
      rFTagNumber: "আরএফ ট্যাগ নম্বর",
      numberAnimalRFTag: "প্রাণী RF ট্যাগের সংখ্যা।",
      govtRegNumb: "সরকার ",
      govtRegistrationNumber: "সনাক্তকরণের বিবরণ যাতে ব্যক্তির নাম এবং ঠিকানা, প্রক্রিয়াটির পরিষেবার জন্য ব্যক্তির এজেন্ট, সম্পাদিত কার্যকলাপের অবস্থান এবং ব্যক্তি যে পরিষেবা প্রদান করে তার বিবরণ অন্তর্ভুক্ত থাকতে পারে।",
      numberAssignedAnimalIsRemoved: "ট্র্যাকিং নম্বর হল পশুদের কার্যকলাপ ট্র্যাক করার জন্য ব্যবহৃত পশুদের আইডিগুলির মধ্যে একটি।",
      dateOfAnimalRegistration: "পশু নিবন্ধনের তারিখ",
      stockBrandDesignSearedHideAnAnimalCattleColorCodeAnAnimal: "ব্র্যান্ড- সহজভাবে একটি স্থায়ী চিহ্ন যা গরুর গায়ে পোড়ানো হয়েছিল।",
      tattoOnAnimal: "পশুর উপর ট্যাটু।",
      whetherTheAnimalIsDehorned: "পশুর শিং আছে কিনা।",
      milkingAnimals: "দুধ খাওয়া প্রাণী",
      studAnimals: "স্টুড প্রাণী",
      animalInseminationRecord: "পশু গর্ভধারণের রেকর্ড",
      numOfStrawsOrdered: "অর্ডারকৃত খড়ের সংখ্যা",
      totalNumOfStraws: "খড়ের মোট সংখ্যা",
      strawId: "খড় আইডি",
      addSireAutomation: "স্যার অটোমেশন যোগ করুন",
      addApprovalAutomation: "অনুমোদন অটোমেশন যোগ করুন",
      addCollectionAutomation: "সংগ্রহ অটোমেশন যোগ করুন",
      addStrawsAutomation: "স্ট্র অটোমেশন যোগ করুন",
      addPackAutomation: "প্যাক অটোমেশন যোগ করুন",
      addPostageAutomation: "ডাক অটোমেশন যোগ করুন",
      searchBySire: "সার্চবাইসায়ার",
      numberOfProgenies: "বংশধরের সংখ্যা",
      sireEdit: "স্যার সম্পাদনা করুন",
      searchByStrawIdtotalNumbersOfStrawsBatchNumberAndLocationId: "খড়ের আইডি, খড়ের মোট সংখ্যা, ব্যাচ নম্বর এবং অবস্থান আইডি দ্বারা অনুসন্ধান করুন",
      searchByPackIdNumberOfStrawsOrderedPackingTechnicia: "প্যাক আইডি, অর্ডারকৃত খড়ের সংখ্যা, প্যাকিং টেকনিশিয়া দ্বারা অনুসন্ধান করুন",
      searchByCollectionAndPreparationTechnicia: "সংগ্রহ এবং প্রস্তুতি প্রযুক্তি দ্বারা অনুসন্ধান",
      registerSemenAutomation: "বীর্য অটোমেশন নিবন্ধন",
      addSemenAutomation: "বীর্য অটোমেশন যোগ করুন",
      strawAutomationRegistered: "খড় অটোমেশন নিবন্ধিত",
      strawAutomationRegisteredNotRegistered: "স্ট্র অটোমেশন নিবন্ধিত নিবন্ধিত নয়",
      sireAutomationRegistered: "স্যার অটোমেশন নিবন্ধিত",
      sireAutomationNotRegistered: "স্যার অটোমেশন নিবন্ধিত নয়",
      postageAutomationIsRegistered: "ডাক অটোমেশন নিবন্ধিত হয়",
      postageAutomationNotRegistered: "ডাক অটোমেশন নিবন্ধিত নয়",
      packAutomationIsRegistered: "প্যাক অটোমেশন নিবন্ধিত হয়",
      packAutomationNotRegistered: "প্যাক অটোমেশন নিবন্ধিত নয়",
      postageAutomationIsUpdated: "ডাক অটোমেশন আপডেট করা হয়",
      postageAutomationNotUpdated: "ডাক অটোমেশন আপডেট করা হয়নি",
      packAutomationIsUpadted: "প্যাক অটোমেশন আপডেট করা হয়েছে",
      packAutomationNotUpadted: "প্যাক অটোমেশন আপডেট করা হয়নি",
      collectionAutomationUpdated: "সংগ্রহ অটোমেশন আপডেট করা হয়েছে",
      collectionAutomationNotUpdated: "সংগ্রহ অটোমেশন আপডেট করা হয়নি",
      approvalAutomationIsUpdated: "অনুমোদন অটোমেশন আপডেট করা হয়",
      approvalAutomationIsNotUpdated: "অনুমোদন অটোমেশন আপডেট করা হয় না",
      collectionAutomationRegistered: "সংগ্রহ অটোমেশন নিবন্ধিত",
      collectionAutomationNotRegistered: "সংগ্রহ অটোমেশন নিবন্ধিত নয়",
      approvalAutomationIsRegistered: "অনুমোদন অটোমেশন নিবন্ধিত হয়",
      approvalAutomationIsNotRegistered: "অনুমোদন অটোমেশন নিবন্ধিত নয়",
      strawAutomationUpdated: "খড় অটোমেশন আপডেট করা হয়েছে",
      strawAutomationIsNotUpdated: "খড় অটোমেশন আপডেট করা হয় না",
      searchSire: "সার্চ স্যার",
      strawsEdit: "স্ট্রস সম্পাদনা করুন",
      nextAnimals: "পরবর্তী প্রাণী",
      performanceInfo: {
        milk: "দুধ",
        liveweight: "লাইভওয়েট",
        score: "স্কোর",
        fertility: "উর্বরতা",
        measurements: "পরিমাপ",
        dailyProteinYield: "দৈনিক প্রোটিন ফলন",
        amountProteinMilkCowDay: "নির্দিষ্ট দিনে একটি গাভী থেকে প্রাপ্ত দুধে প্রোটিনের পরিমাণ।",
        dailyMilkYield: "দৈনিক দুধের ফলন",
        volumeMilkCowDay: "একটি নির্দিষ্ট দিনে একটি নির্দিষ্ট গাভী থেকে প্রাপ্ত দুধের পরিমাণ।",
        dailyFatYield: "দৈনিক চর্বি ফলন",
        amountFatMilkCowDay: "নির্দিষ্ট দিনে গরু থেকে প্রাপ্ত দুধে চর্বির পরিমাণ।",
        dailyProteinContent: "দৈনিক প্রোটিন সামগ্রী",
        dailyFatContent: "দৈনিক চর্বি বিষয়বস্তু",
        milkLactose: "দুধ ল্যাকটোজ",
        amountLactoseMilk: "দুধে ল্যাকটোজ পরিমাণ।",
        milkUrea: "দুধ ইউরিয়া",
        indicatorAmountCrudeProtein: "একটি গরুর খাদ্যে অপরিশোধিত প্রোটিনের পরিমাণ নির্দেশক",
        lactationNumber: "স্তন্যদান সংখ্যা",
        ordinalNumLactation: "স্তন্যপান করানোর সাধারন সংখ্যা।",
        lengthOfLactation: "স্তন্যপান করানোর দৈর্ঘ্য (যেমন 23 দিন)",
        lactationLength: "স্তন্যদানের দৈর্ঘ্য",
        milkingFrequency: "দুধ খাওয়ার ফ্রিকোয়েন্সি",
        frequcnyOfMilking: "দুধ খাওয়ার ফ্রিকোয়েন্সি (যেমন 2 বার/দিন)",
        liveWeightInformation: "লাইভওয়েট তথ্য",
        currentWeight: "বর্তমান ওজন",
        weightAnimal: "পশুর ওজন।",
        postWeaningGain: "পোস্ট-ওয়েনিং লাভ",
        dailyGainInAnimalWeightWeaning: "দুধ ছাড়ার পর পশুর ওজন দৈনিক বৃদ্ধি।",
        weaningWeight: "ওজন কমানো",
        weightAnimalMeasuredWeaning: "দুধ ছাড়ানোর দিনে পশুর ওজন পরিমাপ করা হয়।",
        averageDailyGain: "দৈনিক গড় লাভ",
        averageAmountWeightAnimalGainFeedingPeriod: "খাওয়ানোর সময় প্রতিদিন একটি প্রাণীর গড় ওজন বাড়বে",
        carcassWeight: "মৃতদেহের ওজন",
        weightAnimalsHideInternalOrgansRemoved: "মাথা, চামড়া এবং অভ্যন্তরীণ অঙ্গ অপসারণ করা হয়েছে পরে পশুদের ওজন.",
        weightAtCalving: "calving এ ওজন",
        weightAtTheTimeOfCalving: "বাছুরের সময় ওজন।",
        yearlingWeight: "বার্ষিক ওজন",
        weightYearOldAnimal: "এক বছর বয়সী পশুর ওজন।",
        somaticCellScore: "সোম্যাটিক সেল স্কোর",
        somaticCellScoreIndicatorMastitis: "স্তনপ্রদাহের জন্য একটি সূচক হিসাবে সোম্যাটিক সেল স্কোর। ",
        lastUpdate: "সর্বশেষ আপডেট",
        bodyConditionScore: "শরীরের অবস্থা স্কোর",
        scoreAnimalFat: "কত চর্বি আছে সেই বিষয়ে পশুর একটি স্কোর।  ",
        teatScore: "টিট স্কোর",
        scoreMeasureingShapeTeats: "টিট সাইজ স্কোর হল টিটের দৈর্ঘ্য এবং পরিধির বিষয়ভিত্তিক মূল্যায়ন এবং 9 (খুব ছোট) থেকে 1 (খুব বড়) পর্যন্ত। ",
        udderScore: "উদর সাসপেনশন স্কোর",
        scoreMeasureingShapeOfUdder: "স্কোর মাপার আকৃতি তলপেট (1-9 স্কোর)। ",
        whetherAnimalEasyBirthDifficult: "গবাদি পশুর জন্ম একটি প্রাকৃতিক প্রক্রিয়া কিন্তু কখনও কখনও এমন জন্মগত সমস্যা হতে পারে যেখানে বাঁধের জন্য কৃষক/যাজকদের সাহায্যের প্রয়োজন হয়।",
        totalLongevity: "মোট দীর্ঘায়ু",
        survivalLactationTraitCowCulledBreeding: "1ম থেকে 5ম স্তন্যদান থেকে বেঁচে থাকা। ",
        docility: "নমনীয়তা",
        circumferenceBullScrotal: "ষাঁড়ের অণ্ডকোষের পরিধি",
        intervalSuccessInsemination: "প্রথম থেকে সফল প্রজনন পর্যন্ত ব্যবধান।",
        ageAtFirstCalving: "বয়স এট ফার্স্ট ক্যালভিং",
        ageCowCalving: "প্রথম বাছুরে গরুর বয়স কত।",
        calvingInterval: "ক্যালভিং ব্যবধান",
        periodCalving: "একটি বাছুর থেকে পরবর্তী বাছুর পর্যন্ত সময়কাল।",
        scrotalCircumference: "স্ক্রোটাল পরিধি",
        estrusDetection: "এস্ট্রাস সনাক্তকরণ",
        trackingBehaviorAnimalDetectingEstrus: "একটি গরুর ইস্ট্রাস সনাক্তকরণের জন্য প্রাণীর গতিবিধি ট্র্যাকিং।",
        presenceOfEstrus: "Estrus উপস্থিতি",
        isCowInEstrusStage: "যখন একটি গরু ইস্ট্রাস স্টেজে থাকে বা না হয়",
        matureWeight: "পরিপক্ক ওজন",
        weightAnimalDefinedAge: "একটি নির্দিষ্ট বয়সে একটি প্রাণীর ওজন।",
        matureHeight: "পরিপক্ক উচ্চতা",
        heightAnimalDefinedAge: "নির্ধারিত বয়সে একটি প্রাণীর উচ্চতা।",
        footClawSet: "ফুট নখর সেট",
        shapeAnimalClaw: "প্রাণীর নখর আকৃতি।",
        pulmonaryArterialPressure: "পালমোনারি ধমনী চাপ",
        animalBloodPreasure: "পশুর রক্ত ​​প্রেসার।",
        footAngle: "ফুট কোণ",
        shapeAnimalFoot: "প্রাণীর পায়ের আকৃতি।",
        ribEyeArea: "রিব-আই এরিয়া",
        amountRibEyeArea: "পাঁজর-চোখের এলাকার পরিমাণ।",
        ultrasoundFat: "আল্ট্রাসাউন্ড ফ্যাট",
        measureFatAmount: "চর্বি পরিমাণ পরিমাপ.",
        ultrasoundIntramuscularFat: "আল্ট্রাসাউন্ড ইন্ট্রামাসকুলার ফ্যাট",
        ultrasoundRibEyeArea: "আল্ট্রাসাউন্ড রিব-আই এরিয়া",
        measureRibeyeArea: "Ribeye এলাকা পরিমাপ.",
        fatThickness: "চর্বি পুরুত্ব",
        anmountAnimalBackFat: "পশুর পিঠের চর্বির পরিমাণ।",
        marbling: "মার্বলিং",
        marballingMeasurement: "মার্বলিং হল দৃশ্যমান অসম্পৃক্ত (স্বাস্থ্যকর) ইন্ট্রামাসকুলার চর্বি যা পেশীর মধ্যে এবং পেশী ফাইবার বান্ডিলের মধ্যে জমা হয়।",
        dryMatterIntake: "ড্রাই ম্যাটার ইনটেক",
        amountFeedAnimalConsumesAMoisture: "আর্দ্রতা-মুক্ত ভিত্তিতে একটি প্রাণী প্রতিদিন যে পরিমাণ খাদ্য গ্রহণ করে।"
      },
      feedsName: "ফিডের নাম",
      feedName: "ফিডের নাম",
      firstFeedQuantity: "প্রথম ফিড পরিমাণ",
      additionalFeed: "অতিরিক্ত ফিড",
      cloversRyeGrasses: "ক্লোভার, রাই ঘাস",
      greenFodderHayLegumes: "সবুজ পশুখাদ্য, খড়, লেগুম",
      feedsRegisteredSuccessfully: "ফিডগুলি সফলভাবে নিবন্ধিত হয়েছে৷",
      feedsNotRegistered: "ফিড নিবন্ধিত নয়",
      fEEDQUANTITY: "ফিডের পরিমাণ",
      feedQuantity: "খাওয়ানোর পরিমাণ",
      fEEDNAME: "ফিড নাম",
      nOFEEDINFOAVAILABLE: "কোন ফিড তথ্য উপলব্ধ",
      searchByFeedName: "ফিড নাম দ্বারা অনুসন্ধান করুন",
      loadingFeedInfo: "ফিডের তথ্য লোড হচ্ছে... অনুগ্রহ করে অপেক্ষা করুন",
      todayFeedInfo: "আজ ফিড তথ্য",
      feedInfo: "ফিড তথ্য",
      loremIpsumDolorSitAmet: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. ",
      geneticWorthInfo: {
        breedingValueEconomicIndex: "এই প্রজনন মান অর্থনৈতিক সূচক গণনার জন্য ব্যবহার করা হয় কিনা।",
        dailyProteinYieldUsed: "প্রতিদিন ব্যবহৃত প্রোটিন ফলন",
        weightAssignedBreedingDailyProteinYield: "\"দৈনিক প্রোটিন ফলন\" এর সাথে সামঞ্জস্যপূর্ণ প্রজনন মানের জন্য নির্ধারিত ওজন।",
        dailyProteinYieldWeight: "দৈনিক প্রোটিন ফলন ওজন",
        rankAnimalInRelationshipEconomicIndex: "অর্থনৈতিক সূচকের সাথে সম্পর্কিত প্রাণীর র্যাঙ্ক।",
        economicIndexRank: "অর্থনৈতিক সূচক র\u200c্যাঙ্ক",
        percentileEconomicIndexFall: "শতকরা যে অর্থনৈতিক সূচকে পড়ে।",
        economicIndexPercentile: "অর্থনৈতিক সূচক শতাংশ",
        accuracyOfEconomicIndex: "অর্থনৈতিক সূচকের যথার্থতা।",
        economicIndexAccuracy: "অর্থনৈতিক সূচক নির্ভুলতা",
        weightedAverageOfBreedingValues: "প্রজনন মান ওজনযুক্ত গড়.",
        economicIndex: "অর্থনৈতিক সূচক",
        rankOfAnimalInRelationshipBreeding: "সংশ্লিষ্ট প্রজনন মানের সাথে সম্পর্কযুক্ত প্রাণীর র্যাঙ্ক।",
        dailyProteinYieldBreedingValueRank: "দৈনিক প্রোটিন ফলন প্রজনন মান র্যাঙ্ক ",
        percentileBreedingFalls: "শতকরা যা প্রজনন মান পড়ে।",
        dailyProteinYieldBreedingPercentile: "দৈনিক প্রোটিন ফলন প্রজনন মান শতাংশ ",
        accuracyEstimatedBreeding: "আনুমানিক প্রজনন মূল্যের নির্ভুলতা।",
        dailyProteinYieldBreedingAccuracy: "দৈনিক প্রোটিন ফলন প্রজনন মান নির্ভুলতা",
        estimatedBreedingTraitDailyProteinYield: "বৈশিষ্ট্যের আনুমানিক প্রজনন মান \"দৈনিক প্রোটিন ফলন।",
        dailyProteinYieldBreedingValue: "দৈনিক প্রোটিন ফলন প্রজনন মান ",
        pathToTheDirectoryScriptsBreeding: "প্রজনন মান গণনার জন্য ব্যবহৃত স্ক্রিপ্ট ধারণকারী হার্ড ড্রাইভের ডিরেক্টরির পাথ।",
        scriptsPath: "স্ক্রিপ্ট পাথ",
        softwarePackageBreeding: "সফ্টওয়্যার প্যাকেজ যা প্রজনন মান গণনা করতে ব্যবহৃত হয়েছিল।",
        breedingValueSoftware: "প্রজনন মান সফ্টওয়্যার",
        methodCalculateBreeding: "প্রজনন গণনা করার জন্য যে পদ্ধতি ব্যবহার করা হয়েছিল",
        breedingValueMethod: "প্রজনন মান পদ্ধতি",
        trait: "বৈশিষ্ট্য",
        tools: "টুলস",
        geneticWorth: "জেনেটিক ওয়ার্থ",
        dailyProteinYield: "দৈনিক প্রোটিন ফলন",
        breedingValue: "প্রজনন মান",
        breedingValueBIFAccuracy: "প্রজনন মান BIF নির্ভুলতা",
        breedingValuePercentile: "প্রজনন মান শতাংশ",
        breedingValueRank: "প্রজনন মান র্যাঙ্ক",
        checkLTD: "LTD চেক করুন",
        ultrasoundDiagnostic: "আল্ট্রাসাউন্ড ডায়াগনস্টিক",
        selectYieldUsed: "ব্যবহৃত ফলন নির্বাচন করুন",
        softwareName: "সফটওয়্যারের নাম",
        animalGenWorthUpdatedSuccessfully: "এনিম্যাল জেন ওয়ার্থ সফলভাবে আপডেট হয়েছে"
      },
      addNote: "নোট যোগ করুন",
      enterNote: "নোট লিখুন",
      noteIsRequired: "নোট প্রয়োজন",
      noteMustBeLessThan50Characters: "নোট 50 অক্ষরের কম হতে হবে",
      noteAdded: "নোট যোগ করা হয়েছে",
      noteNotAdded: "নোট যোগ করা হয়নি",
      noteForAnimal: "প্রাণীর জন্য নোট।",
      noNoteFoundForThisAnimal: "এই প্রাণীর জন্য কোন নোট পাওয়া যায়নি।",
      inseminationData: "ইনসেমিনেশন ডেটা",
      nameOfInseminator: "ইনসেমিনেটরের নাম",
      activity: "কার্যকলাপ",
      searchByNameActivity: "নাম, কার্যকলাপ দ্বারা অনুসন্ধান করুন",
      searchByTaskNameNumber: "টাস্ক নাম, নম্বর দ্বারা অনুসন্ধান করুন",
      inseminationDate: "গর্ভধারণের তারিখ",
      genotypeDataInfo: {
        genotypeAnimalID: "জিনোটাইপ প্রাণী আইডি",
        iDTubeBloodSampleAnimalNumberGenotypingService: "এটি একটি টিউবের আইডি যা পশু থেকে নেওয়া রক্তের নমুনা বা একাধিক জিনোটাইপিং পরিষেবা",
        geneticTechnicianName: "জেনেটিক টেকনিশিয়ানের নাম",
        NameTechnicianBloodSamplesAnimal: "এটি একজন টেকনিশিয়ানের নাম যিনি পশুর রক্তের নমুনা নিয়েছেন",
        sNPData: "SNP ডেটা",
        genotypingServiceNote: "জিনোটাইপিং পরিষেবা নোট",
        InfoGenotypingGenotypingTechnology: "জিনোটাইপিং সম্পর্কিত সমস্ত তথ্য যেমন জিনোটাইপিং কোম্পানির নাম, জিনোটাইপিং প্রযুক্তি ব্যবহৃত, জিনোটাইপিংয়ের তারিখ ইত্যাদি",
        numberOfSNPs: "SNP-এর সংখ্যা",
        numberOfSNPsAnimalGenotyped: "SNP-এর সংখ্যা প্রাণীটির জন্য জিনোটাইপ করা হয়েছিল",
        nameOfTheDrug: "ওষুধের নাম",
        animalGenoDataUpdatedSuccessfully: "পশু জিনো ডেটা সফলভাবে আপডেট করা হয়েছে৷",
        animalGenoDataNotUpdated: "প্রাণী জিনো ডেটা আপডেট করা হয়নি",
        animalIDIsRequired: "পশু আইডি প্রয়োজন",
        techNameIsRequired: "প্রযুক্তি. ",
        onlyAlphabetsAreAllowed: "শুধুমাত্র বর্ণমালা অনুমোদিত",
        genoDataIsRequired: "জিনো ডেটা প্রয়োজন",
        serviceNoteIsRequired: "পরিষেবা নোট প্রয়োজন",
        sNPIsRequired: "SNP প্রয়োজন"
      },
      healthRecordInfo: {
        treatment: "চিকিৎসা",
        treatmentTakenAnimal: "পশুর উপর কি চিকিৎসা নেয়া হয়েছে।",
        reasonOfTreatment: "চিকিৎসার কারণ",
        reasonForTreatment: "চিকিৎসার কারণ",
        whatReasonOfTreatment: "চিকিৎসার কারণ কী।",
        treatmentDate: "চিকিৎসার তারিখ",
        dateOfTreatment: "চিকিৎসার তারিখ।",
        diagnosis: "রোগ নির্ণয়",
        nameDiagnosedDiseaseConditionSymptoms: "নির্ণয়কৃত রোগ/পরিস্থিতি বা প্রধান উপসর্গের নাম",
        drugID: "ড্রাগ আইডি",
        iDOfDrugWhichIsGivenToAnimal: "ওষুধের আইডি যা পশুকে দেওয়া হয়।",
        drugName: "ওষুধের নাম",
        nameDrugAnimal: "পশুকে দেওয়া ওষুধের নাম।",
        drugWithdrawalPeriod: "ড্রাগ প্রত্যাহারের সময়কাল",
        timeAdministrationDrugAnimalMeatMilkHumanConsumption: "মানুষের খাওয়ার জন্য মাংস বা দুধের নিরাপত্তা নিশ্চিত করার জন্য একটি পশুকে ওষুধ দেওয়ার পরে প্রয়োজনীয় সময়",
        attendingVeterinarian: "পশুচিকিত্সক যোগদান",
        qualifiedPersonCaseAnimal: "যোগ্য ব্যক্তি যিনি কেস/প্রাণী দেখেছেন",
        packID: "প্যাক আইডি",
        iDPackTreatment: "একটি প্যাকের আইডি যা চিকিত্সার জন্য ব্যবহৃত হয়েছিল",
        veterinarianName: "পশু চিকিৎসকের নাম",
        animalNoHealthRecord: "এই প্রাণীটির কোনো স্বাস্থ্য রেকর্ড নেই। ",
        addHealthRecord: "স্বাস্থ্য রেকর্ড যোগ করুন",
        healthStatus: "স্বাস্থ্য অবস্থা",
        loadingDiseasesPleaseWait: "লোড হচ্ছে রোগ... অনুগ্রহ করে অপেক্ষা করুন",
        animalDiseaseRecord: "পশু রোগের রেকর্ড",
        animalHealthRecord: "পশু স্বাস্থ্য রেকর্ড",
        animalTreatmentRecord: "পশু চিকিৎসার রেকর্ড",
        loadingHealthData: "স্বাস্থ্য ডেটা লোড হচ্ছে...",
        healthRecord: "স্বাস্থ্য রেকর্ড",
        nameOfDiagnosis: "রোগ নির্ণয়ের নাম",
        treatmentName: "চিকিৎসার নাম",
        drugGivenBy: "দ্বারা দেওয়া ড্রাগ",
        recessiveDiseases: "রিসেসিভ রোগ",
        recessiveDiseasesMessage: "এই ষাঁড়টি কোন রিসেসিভ রোগের অ্যালিলের বাহক"
      },
      conceptionInfo: {
        addNewConception: "নতুন ধারণা যোগ করুন",
        semenEmbryo: "বীর্য/ভ্রুণ",
        pregnancyCheck: "গর্ভাবস্থা পরীক্ষা",
        birthInfo: "জন্ম তথ্য",
        searchByInseminatorOrganisationBreedingConception: "ইনসেমিনেটরের নাম, প্রতিষ্ঠানের নাম, প্রজনন পরিষেবা নম্বর, গর্ভধারণের পদ্ধতি দ্বারা অনুসন্ধান করুন",
        deliveryDate: "প্রসবের তারিখ",
        calfId: "বাছুরের আইডি",
        birthDayOldWeight: "জন্ম (দিন পুরানো) ওজন",
        searchByBirthEase: "জন্মের সহজে অনুসন্ধান করুন",
        searchPregnancyCheckOperatorMethod: "গর্ভাবস্থা পরীক্ষা অপারেটর দ্বারা অনুসন্ধান, গর্ভাবস্থা পরীক্ষা পদ্ধতি",
        pregnancyCheckDate: "প্রেগন্যান্সি চেক ডেট",
        conceptionSuccess: "ধারণা সাফল্য",
        pregnancyCheckOperator: "প্রেগন্যান্সি চেক অপারেটর",
        pregnancyCheckMethod: "গর্ভাবস্থা পরীক্ষা পদ্ধতি",
        recentlyPregnant: "সম্প্রতি গর্ভবতী",
        pregnancyConfirmationDate: "গর্ভাবস্থা নিশ্চিতকরণ তারিখ",
        pregnancyRate: "গর্ভাবস্থার হার",
        timePeriodOfPregnancy: "গর্ভাবস্থার সময়কাল",
        semenProduction: "বীর্য উৎপাদন",
        embryoProduction: "ভ্রূণ উৎপাদন",
        semen: "বীর্য",
        embryoTransferDate: "ভ্রূণ স্থানান্তরের তারিখ",
        daysOfPregnancy: "গর্ভাবস্থার দিনগুলি",
        searchSireEmbryoSurrogate: "Sire id, Embryo org নাম, Surrogate dam breed দ্বারা অনুসন্ধান করুন",
        selectDate: "তারিখ নির্বাচন করুন",
        orgnisationNameContainNumber: "প্রতিষ্ঠানের নামে নম্বর থাকা উচিত নয়",
        selectBirthEase: "বার্থ ইজ নির্বাচন করুন",
        selectUnit: "একটি ইউনিট নির্বাচন করুন",
        animalConceptionAddedSuccessfully: "পশু ধারণা সফলভাবে যোগ করা হয়েছে",
        postageCustomerName: "ডাক গ্রাহকের নাম",
        searchByPostageCustNameCustAddPostId: "পোস্টেজ গ্রাহকের নাম, গ্রাহকের ঠিকানা, পোস্ট আইডি দ্বারা অনুসন্ধান করুন",
        dateOfSemenCollection: "বীর্য সংগ্রহের তারিখ",
        dateOfSemenPreparation: "বীর্য প্রস্তুতির তারিখ",
        semenMotility: "বীর্যের গতিশীলতা",
        semenConcentration: "বীর্য ঘনত্ব",
        postageEdit: "ডাক সম্পাদনা",
        enterSireId: "স্যার আইডি লিখুন",
        selectEmbryoOrganisation: "ভ্রূণ সংস্থা নির্বাচন করুন",
        matingDateH: "গর্ভধারণের তারিখ, হয় প্রাকৃতিক মিলন বা কৃত্রিম গর্ভধারণ।",
        inseminatorNameH: "একজন ব্যক্তি যিনি গর্ভধারণ প্রক্রিয়াটি করেন ( পশুচিকিত্সক/প্রযুক্তিবিদ)",
        orgNameH: "AI এর জন্য বীর্য খড় সরবরাহকারী সংস্থা বা সংস্থার নাম৷",
        brServiceNumH: "প্রজননের সংখ্যা রেকর্ড করা (যেমন ১ম, ২য় বা ৩য়)",
        conceptionMethodH: "প্রাণীটি যেভাবে গর্ভধারণ করেছিল তা গর্ভাবস্থার শুরু, শুক্রাণু দ্বারা একটি ডিম্বাণু নিষিক্তকরণ দ্বারা চিহ্নিত৷",
        sireIdH: "পশুর পুরুষ পিতা/মাতার আইডি",
        damIdH: "পশুর মহিলা পিতা/মাতার আইডি।",
        sarogatedDamH: "স্ত্রী গাভীর আইডি যেখানে একজন দাতা পুরুষ এবং দাতা মহিলা থেকে নিষিক্ত ডিম তার আরও বিকাশের জন্য রোপণ করা হয়।",
        embOrgNameH: "ভ্রূণের জন্য সংগঠনের নাম",
        sarogateDamBreedH: "সারোগেট জাতের তারিখ",
        sireBreedH: "সাইর জাতের প্রকার (ব্রাহ্মণ, বোরান)",
        pregCheckDateH: "আল্ট্রাসাউন্ড এবং রক্ত ​​পরীক্ষার মাধ্যমে 30 দিনের মধ্যে গাভীর গর্ভধারণ শনাক্ত করা যায়। প্যালপেশন পদ্ধতি ব্যবহার করে গাভীকে গর্ভবতী হিসাবে চিহ্নিত করার জন্য, প্রায়শই গাভীকে কমপক্ষে 35-50 দিনের গর্ভবতী হতে হবে। ",
        conceptionSuccessH: " গবাদি পশুতে, নিষিক্তকরণের হার 90% যার গড় বাছুর হার প্রায় 55%, যা প্রায় 35% ভ্রূণ-ভ্রূণ মৃত্যুকে নির্দেশ করে (ডিস্কিন এট আল।, 2006)। ",
        pregnancyCheckOperatorH: "পশুচিকিত্সক এবং বিশেষজ্ঞ পশু প্রযুক্তিবিদরা সাধারণত কৃষকদের এই পরিষেবাগুলি প্রদান করেন। ",
        pregnancyCheckMethodH: "গবাদি পশুর গর্ভাবস্থা নির্ণয়ের জন্য দুটি সর্বাধিক ব্যবহৃত পদ্ধতি হল প্রজনন ট্র্যাক্টের ম্যানুয়াল প্যালপেশন (প্রতি মলদ্বার) এবং প্রজনন ট্র্যাক্টের ট্রান্সরেক্টাল আল্ট্রাসনোগ্রাফি",
        deliveryDateH: "জন্ম প্রসবের তারিখ",
        calfIdH: "সদ্যজাত বাছুরের আইডি",
        birthEaseH: "গবাদি পশুর জন্ম একটি প্রাকৃতিক প্রক্রিয়া কিন্তু কখনও কখনও এমন জন্মগত সমস্যা হতে পারে যেখানে বাঁধের জন্য কৃষক/যাজকদের সাহায্যের প্রয়োজন হয়।",
        birthDayOldWeightH: "জন্মের দিনে পশুর ওজন বা একদিন বয়সী পাখির ওজন",
        customerAddress: "গ্রাহকের ঠিকানা"
      },
      all: "সব",
      ungrouped: "গোষ্ঠীবিহীন প্রাণী",
      active: "দলবদ্ধ প্রাণী",
      updateAnimal: "প্রাণী আপডেট করুন"
    },
    dashboardS: {
      dailyActivities: "দৈনন্দিন কার্যক্রম",
      pendingTasks: "মুলতুবি কাজ",
      performanceOfGeno: "জিনোটাইপ কর্মক্ষমতা",
      breed: "বংশবৃদ্ধি",
      chromosome: "ক্রোমোজোম",
      seqChange: "ক্রম পরিবর্তন",
      inheritance: "উত্তরাধিকার",
      diseaseName: "রোগের নাম",
      refSequence: "রেফারেন্স সিকোয়েন্স",
      pubmedRef: "প্রকাশ করা রেফারেন্স",
      matingDate: "মিলনের তারিখ",
      inseminatorName: "ইনসেমিনেটরের নাম",
      orgName: "প্রতিষ্ঠানের নাম",
      brServiceNum: "প্রজনন পরিষেবা নম্বর",
      conceptionMethod: "ধারণা পদ্ধতি",
      semEmbInfo: "বীর্য/ভ্রুণ তথ্য",
      sireId: "স্যার আইডি",
      damID: "ড্যাম আইডি",
      srgDamId: "সারোগেট ড্যাম আইডি",
      embOrgName: "ভ্রূণ সংস্থা। ",
      srgDamBreed: "সারোগেট ড্যাম জাত",
      sireBreed: "স্যার জাত",
      damBreed: "বাঁধ জাত"
    },
    user: {
      selectLanguage: "ভাষা নির্বাচন কর",
      unitPreference: "ইউনিট পছন্দ",
      selectUnitOfMeasure: "পরিমাপের একক নির্বাচন করুন",
      importedUser: "আমদানিকৃত ব্যবহারকারী",
      impFileStatus: "ফাইল স্থিতি আমদানি করুন",
      loadingUser: "ব্যবহারকারী লোড হচ্ছে... অনুগ্রহ করে অপেক্ষা করুন",
      totalUsers: "মোট ব্যবহারকারী",
      pendingUsers: "মুলতুবি ব্যবহারকারী",
      changePassword: "পাসওয়ার্ড পরিবর্তন করুন",
      goodIdeaToUsePassword: "আপনি অন্য কোথাও ব্যবহার করছেন না এমন একটি শক্তিশালী পাসওয়ার্ড ব্যবহার করা একটি ভাল ধারণা।",
      enterCurrentPassword: "বর্তমান পাসওয়ার্ড লিখুন",
      enterNewPassword: "নতুন পাসওয়ার্ড লিখুন",
      reEnterPassword: "নতুন পাসওয়ার্ড পুনরায় লিখুন",
      enterPassword: "পাসওয়ার্ড লিখুন",
      repeatNewPassword: "নতুন পাসওয়ার্ড পুনরাবৃত্তি করুন",
      emailAddr: "ইমেইল ঠিকানা",
      enterYourPhoneNumber: "আপনার ফোন নম্বর লিখুন",
      pleaseTypeOldPassword: "পুরানো পাসওয়ার্ড টাইপ করুন.",
      pleaseTypeNewPassword: "নতুন পাসওয়ার্ড টাইপ করুন.",
      pleaseTypeConfirmPassword: "নিশ্চিত পাসওয়ার্ড টাইপ করুন.",
      passwordChangedSuccesFully: "পাসওয়ার্ড সফলভাবে পরিবর্তন",
      currentPassword: "বর্তমান পাসওয়ার্ড",
      newPassword: "নতুন পাসওয়ার্ড",
      passwordDoesNotMatch: "পাসওয়ার্ড মিলছে না.",
      emailCanNotBeEmpty: "ইমেল খালি হতে পারে না",
      profileUpdated: "প্রোফাইল আপডেট",
      profileNotUpdated: "প্রোফাইল আপডেট করা হয়নি",
      unableToVerifyEmail: "ইমেল যাচাই করতে অক্ষম",
      otpSentOnEmail: "ওটিপি ইমেলে পাঠানো হয়েছে",
      otpSentSuccessFully: "OTP সফলভাবে পাঠানো হয়েছে",
      importUsers: "ব্যবহারকারীদের আমদানি করুন",
      imageUpdated: "ইমেজ আপডেট করা হয়েছে",
      departmentName: "বিভাগ নাম",
      departmentNum: "বিভাগের নম্বর",
      departmentAdded: "বিভাগ যোগ করা হয়েছে",
      departmentNotAdded: "বিভাগ যোগ করা হয়নি",
      searchDepartnment: "বিভাগের নাম বা নম্বর দ্বারা অনুসন্ধান করুন",
      addDepartMent: "বিভাগ যোগ করুন",
      addDepartment: "বিভাগ যোগ করুন",
      roleNameIsRequired: "ভূমিকার নাম প্রয়োজন",
      roleNameMustBeLessThan15Chars: "ভূমিকার নাম অবশ্যই 15 অক্ষরের কম হতে হবে",
      roleAdded: "ভূমিকা যোগ করা হয়েছে",
      editDepartment: "বিভাগ সম্পাদনা করুন",
      departmentUpdated: "বিভাগ আপডেট করা হয়েছে",
      departmentNotUpdated: "বিভাগ আপডেট করা হয়নি",
      deleteDepartment: "বিভাগ মুছুন",
      deleteDepartmentMessage: "আপনি কি নিশ্চিত আপনি এই বিভাগটি মুছে ফেলতে চান?",
      noRoleAvailable: "কোন ভূমিকা উপলব্ধ",
      roleUpdated: "ভূমিকা আপডেট করা হয়েছে",
      roleNotUpdated: "ভূমিকা আপডেট করা হয়নি",
      editRole: "ভূমিকা সম্পাদনা করুন",
      allRole: "সব ভূমিকা",
      addNewRole: "নতুন ভূমিকা যোগ করুন",
      allDepartment: "সমস্ত বিভাগ",
      permissionsUpdated: "অনুমতি আপডেট করা হয়েছে",
      permissionsnotUpdated: "অনুমতি আপডেট করা হয়নি",
      roleNo: "ভূমিকা নং",
      searchByEmailAndName: "ইমেল এবং নাম দ্বারা অনুসন্ধান করুন",
      userID: "ব্যবহারকারী আইডি",
      userUpdated: "ব্যবহারকারী আপডেট করা হয়েছে",
      userNotUpdated: "ব্যবহারকারী আপডেট করা হয়নি",
      userAdded: "ব্যবহারকারী যোগ করা হয়েছে",
      userNotAdded: "ব্যবহারকারী যোগ করা হয়নি",
      activateUser: "ব্যবহারকারী সক্রিয় করুন",
      deactivateUser: "ব্যবহারকারী নিষ্ক্রিয় করুন",
      userStatusMsg: "আপনি কি নিশ্চিত আপনি ব্যবহারকারীর স্থিতি পরিবর্তন করতে চান?",
      countryRequired: "দেশ প্রয়োজন",
      stateRequired: "রাষ্ট্র প্রয়োজন",
      cityRequired: "শহর প্রয়োজন",
      searchByRole: "রোল নম্বর, ভূমিকার নাম, বিভাগ দ্বারা অনুসন্ধান করুন",
      noModuleAvailable: "কোন মডিউল উপলব্ধ নেই",
      searchBYModuleName: "মডিউল নাম দ্বারা অনুসন্ধান করুন"
    },
    farm: {
      farmID: "ফার্ম আইডি",
      onTheFarm: "খামারে",
      userRoles: "ব্যবহারকারীর ভূমিকা",
      adduser: "ব্যবহারকারী যোগ করুন",
      addAuser: "একটি ব্যবহারকারী যোগ করুন",
      uploadUsers: "ব্যবহারকারীদের আপলোড করুন",
      addNewUser: "নতুন ব্যবহারকারী যোগ করুন",
      selectDept: "বিভাগ নির্বাচন করুন",
      selectRole: "ভূমিকা নির্বাচন করুন",
      editUser: "ব্যবহারকারী সম্পাদনা করুন",
      totalFarms: "মোট খামার",
      NoAnimalsRegisteredForthisFarm: "এই খামারের জন্য কোন প্রাণী নিবন্ধিত হয় না",
      farmsPerPage: "পৃষ্ঠা প্রতি খামার",
      regularFarms: "নিয়মিত খামার",
      farmRegisteredProducts: "খামার নিবন্ধিত পণ্য",
      searchByFarmNameAndId: "খামারের নাম এবং আইডি দ্বারা অনুসন্ধান করুন",
      loadingProductsPleaseWait: "পণ্য লোড হচ্ছে... অনুগ্রহ করে অপেক্ষা করুন",
      farmName: "খামারের নাম",
      farmLocation: "খামারের অবস্থান",
      productName: "পণ্যের নাম",
      stockStatus: "স্টক অবস্থা",
      inStock: "স্টকে",
      searchByProductName: "পণ্যের নাম দ্বারা অনুসন্ধান করুন",
      productCategory: "পণ্য তালিকা",
      products: "পণ্য",
      farms: "খামার",
      registerAfarm: "একটি খামার নিবন্ধন",
      govtRegistry: "সরকার ",
      cooperativeID: "সমবায় আইডি",
      farmType: "খামারের ধরন",
      contractMating: "কন্ট্রাক্ট মেটিং",
      customization: "কাস্টমাইজেশন",
      recordsPerpage: "পৃষ্ঠা প্রতি রেকর্ড",
      restoreDefault: "সাধারনে প্রত্যাবর্তন",
      apply: "আবেদন করুন",
      searchState: "ফার্ম আইডি, গভর্নমেন্ট রেজিস্ট্রি, কোঅপারেটিভ আইডি, ফার্ম টাইপ, কন্ট্রাক্ট মেটিং দ্বারা অনুসন্ধান করুন",
      farmOwner: "খামারের মালিক",
      govRegistrationNo: "সরকারী নিবন্ধন নম্বর",
      farmInformation: "খামার তথ্য",
      ownershipType: "মালিকানার ধরন",
      communityName: "সম্প্রদায় নাম",
      farmLicenseInformation: "খামার লাইসেন্স তথ্য",
      licenseNumber: "অনুজ্ঞাপত্র নম্বর",
      licenseExpiryDate: "লাইসেন্সের মেয়াদ শেষ হওয়ার তারিখ",
      regulatorName: "নিয়ন্ত্রকের নাম",
      regulatorRepresentativeName: "নিয়ন্ত্রক প্রতিনিধির নাম",
      farmLocationSize: "খামারের অবস্থান",
      productionSystem: "উৎপাদন ব্যবস্থা",
      country: "দেশ",
      state: "অবস্থা",
      city: "শহর",
      street: "রাস্তা",
      houseNumber: "বাড়ির নম্বর",
      farmRegistration: "খামার নিবন্ধন",
      cancel: "বাতিল করুন",
      register: "নিবন্ধন",
      ok: "ঠিক আছে",
      totalFarmSize: "খামারের মোট আকার",
      farmGeographicLocation: "খামার ভৌগলিক অবস্থান",
      perimeterPointLongitude: "পরিধি বিন্দু দ্রাঘিমাংশ",
      perimeterPointLatitude: "পরিধি বিন্দু অক্ষাংশ",
      perimeterPointLabel: "পেরিমিটার পয়েন্ট লেবেল",
      perimeterLength: "পরিধি দৈর্ঘ্য",
      farmLatitude: "খামার অক্ষাংশ",
      farmLongitude: "খামার দ্রাঘিমাংশ",
      editFarm: "খামার সম্পাদনা করুন",
      update: "হালনাগাদ",
      editAfarm: "একটি খামার সম্পাদনা করুন",
      nextFarm: "পরবর্তী খামার",
      nameoftheFarm: "খামারের নাম",
      registerAProduct: " একটি পণ্য নিবন্ধন",
      farmProducts: "খামার পণ্য",
      calf: "বাছুর",
      steer: "হাল ধরা",
      heifer: "হেইফার",
      sire: "স্যার",
      dam: "বাঁধ",
      registerAnAnimal: "একটি প্রাণী নিবন্ধন",
      farmAnimals: "খামারের প্রাণী",
      farm_type: "ফার্ম-টাইপ",
      farm_Owner: "খামার-মালিক",
      dateOfRegistration: "নিবন্ধনের তারিখ",
      dataIsNotAvailableForThisFarm: "এই খামারের জন্য ডেটা উপলব্ধ নয়",
      registerNewProduct: "একটি নতুন পণ্য নিবন্ধন করুন",
      information: "তথ্য",
      licenseInfo: "লাইসেন্স তথ্য",
      locationInfo: "অবস্থান তথ্য",
      geoLocation: "জিও অবস্থান",
      perimeterLengthState: "খামারের পরিধির দৈর্ঘ্য (বেড়ার দৈর্ঘ্য)",
      totalFarmSizeState: "একটি খামারের আকার",
      productionSystemState: "খামারে ব্যবহৃত উৎপাদন ব্যবস্থা",
      contractMatingState: "কন্ট্রাক্ট মেটিং প্রোগ্রামের কোড যেখানে ফার্ম অংশগ্রহণ করে।",
      ownershipTypeState: "মালিকানার ধরন",
      regulatorRepresentativeNameState: "লাইসেন্স প্রকাশকারী নিয়ন্ত্রকের প্রতিনিধিত্বকারী ব্যক্তির নাম",
      regulatorNameState: "লাইসেন্স প্রকাশকারী নিয়ন্ত্রকের নাম",
      licenseExpiryDateState: "বর্তমান লাইসেন্সের মেয়াদ শেষ হওয়ার তারিখ",
      licenseNumberState: "নিয়ন্ত্রক দ্বারা প্রকাশিত লাইসেন্স নম্বর",
      plotNumberState: "খামারের বাড়ির নম্বর।",
      plotNumber: "বাড়ি/প্লট নম্বর",
      streetStatement: "খামারের রাস্তার নাম।",
      cityStatement: "যে শহরে খামারটি অবস্থিত।",
      stateStatement: "দেশের যে অঞ্চলে খামারটি অবস্থিত।",
      countryState: "যে দেশে খামারটি অবস্থিত।",
      perimeterPointLongitudeState: "খামারে এক বিন্দুর দ্রাঘিমাংশ।",
      perimeterPointLatitudeState: "খামারে এক বিন্দুর অক্ষাংশ।",
      perimeterPointLabelState: "পয়েন্টের লেবেল।",
      farmLongitudeState: "খামারের দ্রাঘিমাংশ।",
      farmLatitudeState: "খামারের অক্ষাংশ।",
      farmNameH: "খামারের নাম",
      farmTypeH: "খামারের ধরন যেখানে বিভিন্ন কার্যক্রম পরিচালিত হয়।",
      farmOwnerH: "একটি খামারের মালিকের নাম (স্বয়ংক্রিয়ভাবে উৎপন্ন কৃষকের নাম তথ্য প্রবেশ করানো)",
      ownershipTypeH: "কৃষকদের ধরন যারা চাষের জমির মালিক/নিয়ন্ত্রণ করেন এবং যারা করেন না।",
      govtRegNumbH: "খামারের রেজিস্ট্রি নম্বর যা নিয়ন্ত্রক দ্বারা নির্ধারিত হয়েছিল",
      contractMatingH: "চুক্তির মিলন প্রোগ্রামের কোড যা খামার অংশগ্রহণ করে",
      productionSystemH: "খামারে কি উৎপাদন ব্যবস্থা ব্যবহার করা হয়",
      cooperativeIDH: "একটি সমবায়ের আইডি যার ফার্ম সদস্য ",
      licenseNumberH: "নিয়ন্ত্রক দ্বারা প্রকাশিত লাইসেন্সে শনাক্তকরণ নম্বর যা এটি মালিকের সাথে সনাক্ত করে।",
      licenseExpiryDateH: "বর্তমান লাইসেন্সের মেয়াদ শেষ হওয়ার তারিখ",
      regularNameH: "লাইসেন্স প্রকাশকারী নিয়ন্ত্রকের নাম",
      regularRepName: "লাইসেন্স প্রকাশকারী নিয়ন্ত্রকের প্রতিনিধিত্বকারী ব্যক্তির নাম",
      countryH: "যে দেশে খামারটি অবস্থিত।",
      stateH: "দেশের যে অঞ্চলে খামারটি অবস্থিত।",
      cityH: "যে শহরে খামারটি অবস্থিত।",
      streetH: "খামারের রাস্তার নাম।",
      houseNumberH: "খামারের বাড়ির নম্বর।",
      totalFarmSizeH: "খামারের আকার হল সেই জমির সমষ্টি যা বর্তমানে খামার দ্বারা চাষ করা হয় যার মধ্যে পতিত জমি রয়েছে কিন্তু প্রাকৃতিক গাছপালা, গাছ বা চারণভূমির অধীনে থাকা জমি বাদ দিয়ে।",
      farmLatitudeH: "নিরক্ষরেখার উত্তর বা দক্ষিণে দূরত্বের পরিমাপ। ",
      farmLongitudeH: "এটি প্রাইম মেরিডিয়ানের পূর্ব বা পশ্চিমে দূরত্ব পরিমাপ করে।",
      perimeterLengthH: "খামারের পরিধির দৈর্ঘ্য (বেড়ার দৈর্ঘ্য)",
      perimeterPointLabelH: "পয়েন্টের লেবেল। ",
      perimeterPointLatH: "খামারে এক বিন্দুর অক্ষাংশ",
      perimeterPointLongH: "খামারে এক বিন্দুর দ্রাঘিমাংশ",
      noProductAvailable: "কোন পণ্য উপলব্ধ",
      farmUpdated: "খামার আপডেট করা হয়েছে",
      performance: "কর্মক্ষমতা",
      milkInformation: "দুধের তথ্য",
      farmNameRequired: "খামারের নাম প্রয়োজন"
    },
    login: {
      welcome: "স্বাগত! ",
      welInfo: "আপনার শংসাপত্র লিখুন.",
      login: "প্রবেশ করুন",
      forgotPassword: "পাসওয়ার্ড ভুলে গেছেন",
      forgotPasswordDesc: "আপনার অ্যাকাউন্টের সাথে যুক্ত ইমেইল ঠিকানা লিখুন। ",
      backToLogin: "প্রবেশ করতে পেছান"
    },
    actionListmod: {
      actionList: "কার্য তালিকা",
      tODAY: "আজ",
      createTask: "টাস্ক তৈরি করুন",
      myActivities: "আমার কার্যক্রম",
      jhonSmith: "জন স্মিথ",
      farmID: "ফার্ম আইডি",
      dateOfEvent: "ইভেন্টের তারিখ",
      actionRequired: "অ্যাকশন প্রয়োজন",
      actionTaken: "ব্যবস্থা নেওয়া হয়েছে",
      animalEventID: "প্রাণী ইভেন্ট আইডি",
      cANCEL: "বাতিল করুন",
      cONFIRM: "নিশ্চিত করুন",
      sTATEMENT: "আপনি কি নিশ্চিত আপনি এই রেকর্ড মুছে ফেলতে চান?",
      dAY: "দিন",
      wEEK: "সপ্তাহ",
      mONTH: "মাস",
      sUBMIT: "জমা দিন",
      startDate: "শুরুর তারিখ",
      endDate: "শেষ তারিখ",
      rEPEAT: "পুনরাবৃত্তি করুন",
      taskCategory: "টাস্ক ক্যাটাগরি",
      pRIORITY: "অগ্রাধিকার",
      aSSIGNEE: "অর্পণকারী",
      selectLocation: "স্থান নির্বাচন করুন",
      selectAnimals: "এক বা একাধিক প্রাণী নির্বাচন করুন",
      dESCRIPTION: "বর্ণনা",
      customRecurrence: "কাস্টম পুনরাবৃত্তি",
      repeatEvery: "প্রতি পুনরাবৃত্তি",
      taskName: "টাস্কের নাম",
      enterDescription: "বর্ণনা লিখুন",
      toDo: "করতে",
      assignTo: "ধার্য",
      status: "স্ট্যাটাস",
      nOTE: "বিঃদ্রঃ",
      noTaskAvailable: "কোন টাস্ক উপলব্ধ নেই",
      healthRecord: "স্বাস্থ্য রেকর্ড",
      iD: "আইডি",
      tAG: "ট্যাগ",
      dateOfbirth: "জন্ম তারিখ",
      taskTakenat: "টাস্ক নেওয়া হয়েছে",
      gENDER: "লিঙ্গ",
      bREED: "বংশবৃদ্ধি",
      regDate: "রেজি. ",
      updateHealthRecord: "পশুদের জন্য স্বাস্থ্য রেকর্ড আপডেট করুন",
      treatment: "চিকিৎসা",
      reasonOftreatment: "চিকিৎসার কারণ",
      treatmentDate: "চিকিৎসার তারিখ",
      dIAGNOSIS: "রোগ নির্ণয়",
      drugId: "ড্রাগ আইডি",
      drugName: "ওষুধের নাম",
      drugWithdrawalperiod: "ড্রাগ প্রত্যাহারের সময়কাল",
      attendingVeterinarian: "পশুচিকিত্সক যোগদান",
      packId: "প্যাক আইডি",
      noItemsselected: "কোন আইটেম নির্বাচন করা হয়নি",
      healthRecordsubmission: "স্বাস্থ্য রেকর্ড জমা",
      inseminationRecordsubmission: "গর্ভধারণ-রেকর্ড জমা",
      inseminatorName: "ইনসেমিনেটরের নাম",
      inseminatorId: "ইনসেমিনেটর আইডি",
      conceptionRate: "গর্ভধারণের হার",
      dateOfmeasurement: "পরিমাপের তারিখ",
      recordSubmission: "রেকর্ড জমা",
      uPDATE: "হালনাগাদ",
      updateTask: "টাস্ক আপডেট করুন"
    },
    inseminatorStatisticsInfo: {
      addInseminatorInfo: "ইনসেমিনেটর তথ্য যোগ করুন",
      inseminatorNumber: "ইনসেমিনেটর নম্বর",
      loadingInseminatorPleaseWait: "ইনসেমিনেটর লোড হচ্ছে... অনুগ্রহ করে অপেক্ষা করুন",
      searchByIDAndName: "আইডি এবং নাম দ্বারা অনুসন্ধান করুন",
      inseminatorInfoAdded: "ইনসেমিনেটর তথ্য যোগ করা হয়েছে",
      inseminatorInfoNotAdded: "ইনসেমিনেটর তথ্য যোগ করা হয়নি",
      inseminatorInfoUpdated: "ইনসেমিনেটর তথ্য আপডেট করা হয়েছে",
      inseminatorInfoNotUpdated: "ইনসেমিনেটর তথ্য আপডেট করা হয়নি",
      editAInseminatorInfo: "ইনসেমিনেটর তথ্য সম্পাদনা করুন",
      inseminatorList: "ইনসেমিনেটর তালিকা",
      inseminatorInfoDetails: "ইনসেমিনেটর তথ্য বিবরণ",
      updateInseminatorInfo: "ইনসেমিনেটর তথ্য আপডেট করুন"
    },
    organizationNtrInfo: {
      loadingOrdersPleaseWait: "অর্ডার লোড হচ্ছে... অনুগ্রহ করে অপেক্ষা করুন",
      addStocks: "স্টক যোগ করুন",
      addStock: "স্টক যোগ করুন",
      quantity: "পরিমাণ",
      selectUnit: "ইউনিট নির্বাচন করুন",
      farmProducts: "খামার পণ্য",
      cost: "খরচ",
      transactionID: "লেনদেন নাম্বার",
      recipientID: "প্রাপক আইডি",
      orderID: "অর্ডার আইডি",
      recepientName: "প্রাপকের নাম",
      createAOrder: "একটি আদেশ তৈরি করুন",
      totalStocks: "মোট স্টক",
      orders: "আদেশ",
      totalPending: "মোট পেন্ডিং",
      totalDelivered: "মোট বিতরণ করা হয়েছে",
      searchByRecepientNameOrderIdRecepientId: "প্রাপকের নাম, অর্ডার আইডি, প্রাপকের আইডি দ্বারা অনুসন্ধান করুন",
      chooseTheDate: "তারিখ নির্বাচন করুন",
      transactionDate: "লেনদেন তারিখ",
      selectCategory: "বিভাগ নির্বাচন করুন",
      volumeOfProduct: "পণ্যের পরিমাণ",
      productQuantity: "পণ্যের পরিমাণ",
      productRecipientId: "পণ্য প্রাপক আইডি",
      productRecipientName: "পণ্য প্রাপকের নাম",
      productRecipientType: "পণ্য প্রাপকের ধরন",
      singleProduct: "একক পণ্য",
      orderPlaced: "আদেশ স্থাপন",
      orderNotPlaced: "অর্ডার দেওয়া হয়নি",
      totalPrice: "মোট দাম",
      currency: "মুদ্রা",
      selectCurrency: "কারেন্সি নির্বাচন করুন",
      address: "ঠিকানা",
      enterAddress: "ঠিকানা লিখুন",
      attachments: "সংযুক্তি",
      chooseFile: "ফাইল পছন্দ কর",
      nameOfTheFarm: "খামারের নাম",
      loremIpsumHasBeenTheIndustrySStandardDummyText: "লোরেম ইপসাম 1500 এর দশক থেকে শিল্পের স্ট্যান্ডার্ড ডামি টেক্সট হয়েছে, যখন একটি অজানা প্রিন্টার",
      billedTo: "বিল",
      orderStatus: "অর্ডারের অবস্থা",
      selectStatus: "স্থিতি নির্বাচন করুন",
      cadbury: "ক্যাডবেরি",
      totalAmount: "সর্বমোট পরিমাণ",
      deliveryCharges: "ডেলিভারি চার্জ",
      orderDetails: "আদেশ বিবরণী",
      deliveryOnTime: "সময়মত ডেলিভারি",
      productID: "পণ্য আইডি",
      productRegistration: "পণ্য নিবন্ধন",
      enterTheNameOfTheProduct: "পণ্যের নাম লিখুন",
      nameOfTheProduct: "পণ্যের নাম",
      productAdded: "পণ্য যোগ করা হয়েছে",
      productNotAdded: "পণ্য যোগ করা হয়নি"
    },
    drug: {
      dRUGS: "ওষুধের",
      registerAdrug: "একটি ড্রাগ নিবন্ধন",
      sEARCH: "অনুসন্ধান করুন",
      genericName: "জেনেরিক নাম",
      manufacturer: "প্রস্তুতকারক",
      distributor: "পরিবেশক",
      registrationDate: "নিবন্ধনের তারিখ",
      drugRegistration: "ড্রাগ নিবন্ধন",
      drugInformation: "ড্রাগ তথ্য",
      packExpiration: "প্যাকের মেয়াদ শেষ",
      drugId: "ড্রাগ আইডি",
      drugName: "ওষুধের নাম",
      drugGenericname: "ওষুধের জেনেরিক নাম",
      drugManufacturer: "ওষুধ প্রস্তুতকারক",
      distributorName: "পরিবেশকের নাম",
      drugRegistrationdate: "ড্রাগ রেজিস্ট্রেশনের তারিখ",
      nextDrug: "পরবর্তী ড্রাগ",
      editDrug: "ওষুধ সম্পাদনা করুন",
      updateDrug: "আপডেট ড্রাগ",
      deleteDrug: "ড্রাগ মুছুন",
      noRecordfound: "পাওয়া কোন রেকর্ড",
      addDrug: "ড্রাগ যোগ করুন",
      statementDrug: "ওষুধটি মুছে ফেলা হয়েছে।  ",
      cANCEL: "বাতিল করুন",
      cONFIRM: "নিশ্চিত করুন",
      sTATEMENT: "আপনি কি নিশ্চিত আপনি এই রেকর্ড মুছে ফেলতে চান?",
      ok: " ঠিক আছে",
      information: "তথ্য",
      packOrder: "প্যাক অর্ডার",
      packPrescription: "প্যাক প্রেসক্রিপশন",
      packReservation: "প্যাক রিজার্ভেশন",
      packLocation: "প্যাক অবস্থান",
      drugDozedam: "ড্যামের জন্য একদিনে ওষুধের ডোজ",
      drugDozecalf: "বাছুরের জন্য একদিনে ওষুধের ডোজ",
      drugFormate: "ড্রাগ ফরম্যাট",
      drugDistributor: "ওষুধ পরিবেশক",
      drugActiveingridents: "ড্রাগ সক্রিয় উপাদান",
      drugSubstitutionId: "ড্রাগ প্রতিস্থাপন আইডি",
      packId: "প্যাক আইডি",
      packBatchNumber: "প্যাক ব্যাচ নম্বর",
      drugIdStatement: "ওষুধের ব্যাচ নম্বর।",
      drugNameSatement: "বিজ্ঞাপনী ব্র্যান্ডের নাম যার অধীনে ওষুধ বিক্রি হয়।",
      drugGenericnameStatement: "একটি ওষুধের রাসায়নিক মেকআপ বিজ্ঞাপনের ব্র্যান্ড নামের পরিবর্তে যার অধীনে ওষুধ বিক্রি হয়।",
      drugFormateSatement: "ওষুধের ব্যাচ নম্বর।",
      drugDozecalfSatement: "বাছুরের ওষুধের ডোজ পরিমাণ জানতে।",
      drugDozedamStatement: "ড্যাম ড্রাগ ডোজ পরিমাণ জানতে.",
      drugManufacturerStatement: "ওষুধ প্রস্তুতকারকের বিশদ বিবরণ।",
      drugDistributorStatement: "ওষুধ বিতরণকারীর বিবরণ।",
      drugRegistrationdateStatement: "নির্দিষ্ট দেশে ওষুধ নিবন্ধনের তারিখ।",
      drugActiveingridentsStatement: "সক্রিয় উপাদানের তালিকা।",
      drugSubstitutionIdStatement: "মূল ওষুধটি বর্তমানে অনুপলব্ধ হলে ওষুধের সম্ভাব্য প্রতিস্থাপনের আইডি।",
      packIdStatement: "প্যাকের বার কোড বা আরএফ আইডি।",
      packBatchNumberStatement: "প্রস্তুতকারকের দ্বারা প্যাকে নির্ধারিত ব্যাচ নম্বর।",
      locationWarehouseID: "অবস্থান গুদাম আইডি",
      locationWarehouseIDState: "গুদামের আইডি যেখানে প্যাকটি সংরক্ষণ করা হয়।",
      locationRackID: "অবস্থান র্যাক আইডি",
      locationRackIDStatement: "র্যাকের আইডি যেখানে প্যাকটি সংরক্ষণ করা হয়।",
      locationTierID: "অবস্থান স্তর আইডি",
      locationTierIDStatement: "র্যাকের স্তরের আইডি যেখানে প্যাকটি সংরক্ষণ করা হয়।",
      locationPositionID: "অবস্থান অবস্থান আইডি",
      locationPositionIDStatement: "একটি স্তরের অবস্থানের আইডি যেখানে প্যাকটি সংরক্ষণ করা হয়।",
      storageTemperatureCondition: "স্টোরেজ তাপমাত্রার অবস্থা",
      storageTemperatureConditionStats: "প্যাক সংরক্ষণের শর্ত।",
      containerForm: "ধারক ফর্ম",
      containerFormStatement: "পাত্রের ফর্ম যেখানে ওষুধটি প্যাক করা হয়েছিল।",
      consistQuantity: "পরিমাণ সমন্বয়",
      consistQuantityStatement: "প্যাকে থাকা বড়ি, বোতল ইত্যাদির পরিমাণ।",
      releaseId: "রিলিজ আইডি",
      releaseIdStatement: "প্যাকটি কৃষকের নেওয়ার পরে বরাদ্দকৃত আইডি।",
      releaseDate: "মুক্তির তারিখ",
      releaseDateStatement: "কৃষকের স্টক থেকে প্যাকটি নেওয়ার তারিখ।",
      packManufacturedDate: "প্যাক তৈরির তারিখ",
      packManufacturedDateStatement: "প্যাকটি তৈরি করার তারিখ।",
      packImportedDate: "প্যাক আমদানির তারিখ",
      packImportedDateStatement: "প্যাকটি আমদানি করার তারিখ।",
      packExpirationDate: "প্যাকের মেয়াদ শেষ হওয়ার তারিখ",
      packExpirationDateStatement: "প্যাকটির মেয়াদ শেষ হওয়ার তারিখ।",
      expiredSoonFlag: "মেয়াদ শেষ শীঘ্রই পতাকা",
      expiredSoonFlagState: "প্যাকটির মেয়াদ শীঘ্রই শেষ হওয়ার বিষয়ে সতর্কতা।",
      packTotalVolumeLeft: "প্যাক মোট ভলিউম বাম",
      packTotalVolumeLeftState: "স্টক বাকি একই উপাদান সঙ্গে প্যাক মোট সংখ্যা.",
      packOrderID: "প্যাক অর্ডার আইডি",
      packOrderIDState: "ডিস্ট্রিবিউটর থেকে প্যাক অর্ডার করার পরে আইডি যা বরাদ্দ করা হয়েছিল।",
      packQuantityOrdered: "প্যাক পরিমাণ আদেশ",
      packQuantityOrderedState: "ডিস্ট্রিবিউটর থেকে অর্ডার করা প্যাকের সংখ্যা।",
      packPrice: "প্যাক মূল্য",
      packPriceStatement: "প্যাকের দাম।",
      priceCurrency: "মূল্য মুদ্রা",
      packPricecurrency: "প্যাক মূল্য মুদ্রা",
      packPricecurrencyState: "মুদ্রার নাম যাতে মূল্য মনোনীত হয়।",
      packPaydate: "প্যাক পে তারিখ",
      payDate: "পে তারিখ",
      packPaydateState: "ডিস্ট্রিবিউটরকে পেমেন্ট রিলিজ করার তারিখ।",
      packShippingID: "প্যাক শিপিং আইডি",
      shippingID: "শিপিং আইডি",
      packShippingIdState: "প্যাকটির শিপিং আইডি যখন ডিস্ট্রিবিউটর থেকে আসে।",
      packShippingDate: "প্যাক শিপিং তারিখ",
      shippingDate: "শিপিং তারিখ",
      packShippingDateState: "স্টকে প্যাক আসার তারিখ।",
      packOrderStatus: "প্যাক অর্ডার স্ট্যাটাস",
      packOrderStatusState: "বর্তমান আদেশের অবস্থা।",
      recepientKeeperId: "প্রাপক কিপার আইডি",
      recepientKeeperIdStatement: "যে ব্যক্তি/সংস্থা প্যাকটি পেয়েছে তার নাম।",
      recepientFarmId: "প্রাপক ফার্ম আইডি",
      recepientFarmIdStatement: "ফার্মের আইডি যেখানে পশুলাল ওষুধের রশিদ রয়েছে।",
      recepientAnimalId: "প্রাপক প্রাণী আইডি",
      recepientAnimalIdState: "পশুর আইডি যাকে ওষুধ (প্যাক) দেওয়া হয়েছিল।",
      specialistComments: "বিশেষজ্ঞ মন্তব্য",
      specialistCommentsState: "প্রেসক্রিপশন সম্পর্কে বিশেষজ্ঞ/ভেটেরিনারিদের মন্তব্য।",
      specialistName: "বিশেষজ্ঞের নাম",
      specialistNameState: "বিশেষজ্ঞ/পশুচিকিৎসকের নাম যিনি ওষুধটি লিখেছিলেন।",
      specialistID: "বিশেষজ্ঞ আইডি",
      specialistIDState: "বিশেষজ্ঞ/পশুচিকিৎসকের আইডি যিনি ওষুধটি লিখেছিলেন।",
      reservedByKeeperId: "কিপার আইডি দ্বারা সংরক্ষিত",
      reservedByKeeperIdState: "প্যাকটি কে রিজার্ভ করেছে তার কিপার আইডি।",
      reservedByFarmId: "ফার্ম আইডি দ্বারা সংরক্ষিত",
      reservedByFarmIdState: "ফার্ম আইডি যার জন্য প্যাকটি সংরক্ষিত।",
      reservationTimeoutDate: "রিজার্ভেশন টাইমআউট তারিখ",
      reservationTimeoutDateState: "প্যাকটি কেনা না হলে রিজার্ভেশন স্বয়ংক্রিয়ভাবে বাতিল হয়ে যাওয়ার তারিখ।",
      reservationTimeout: "সংরক্ষণের সময়সীমা",
      reservationTimeoutState: "কত ঘন্টা পরে প্যাকটি কেনা বা নেওয়া না হলে রিজার্ভেশন স্বয়ংক্রিয়ভাবে বাতিল হয়ে যাবে",
      reservationDate: "সংরক্ষণের তারিখ",
      reservationDateState: "প্যাকের সংরক্ষণের তারিখ।",
      reservationStatus: "সংরক্ষণের অবস্থা",
      reservationStatusState: "প্যাক রিজার্ভেশন অবস্থা. ",
      loadingDrugsPleaseWait: "ওষুধ লোড হচ্ছে... অনুগ্রহ করে অপেক্ষা করুন",
      quantityOrder: "পরিমাণ অর্ডার",
      keeperID: "কিপার আইডি",
      timeoutDate: "সময়সীমা শেষ হওয়ার তারিখ",
      warehouseID: "গুদাম আইডি",
      rackID: "র্যাক আইডি",
      tierID: "টিয়ার আইডি",
      positionID: "অবস্থান আইডি",
      temperatureCondition: "তাপমাত্রার অবস্থা",
      manufactureDate: "অস্ত্রোপচার",
      importedDate: "আমদানির তারিখ",
      totalVolumeLeft: "মোট ভলিউম বাম"
    },
    reports: {
      myReports: "আমার রিপোর্ট",
      satelliteReports: "স্যাটেলাইট রিপোর্ট",
      weatherReports: "আবহাওয়া রিপোর্ট",
      pregnancyAnalytics: "গর্ভাবস্থা বিশ্লেষণ",
      semenEmbroyAnalytics: "বীর্য/ভ্রুণ বিশ্লেষণ",
      semenAnalytics: "বীর্য বিশ্লেষণ",
      embryoAnalytics: "ভ্রূণ বিশ্লেষণ",
      calfAnalytics: "বাছুর বিশ্লেষণ",
      milkProduction: "দুধ উৎপাদন",
      totalMilkType: "মোট দুধের ধরন",
      totalAnimalAnalytics: "মোট প্রাণী বিশ্লেষণ",
      animalAnalytics: "প্রাণী বিশ্লেষণ",
      analyticsAndReporting: "বিশ্লেষণ এবং রিপোর্টিং",
      filterByCountry: "দেশ অনুসারে ফিল্টার করুন",
      filterByFarm: "খামার দ্বারা ফিল্টার",
      filterByRegion: "অঞ্চল অনুসারে ফিল্টার করুন",
      filterByMonth: "মাস অনুযায়ী ফিল্টার করুন",
      filterByDate: "তারিখ অনুসারে ফিল্টার করুন",
      filterByRole: "ভূমিকা দ্বারা ফিল্টার",
      filterByYear: "বছর অনুসারে ফিল্টার করুন",
      filterByTrait: "বৈশিষ্ট্য দ্বারা ফিল্টার",
      avgBreedingValue: "গড় প্রজনন মান",
      avgEconomicIndex: "গড় অর্থনৈতিক সূচক",
      breederReport: "ব্রিডার রিপোর্ট",
      semenTransferDate: "বীর্য স্থানান্তরের তারিখ",
      semenEmbryoProductionReport: "বীর্য/ভ্রূণ উৎপাদন রিপোর্ট",
      semenProducts: "বীর্য পণ্য",
      meatProducts: "মাংস পণ্য",
      totalProducts: "মোট পণ্য",
      semenEmbryoReport: "বীর্য/ভ্রুণ রিপোর্ট",
      numOfStraws: "খড়ের সংখ্যা",
      collectionDate: "সংগ্রহ তারিখ",
      productionReport: "উৎপাদন প্রতিবেদন",
      receipientId: "প্রাপক আইডি",
      embryoId: "ভ্রূণ আইডি",
      semenStrawId: "বীর্য খড় আইডি",
      dataScientist: "ডেটা সায়েন্টিস্ট",
      dataScientistReport: "ডেটা সায়েন্টিস্ট রিপোর্ট",
      productReport: "পণ্য রিপোর্ট",
      dairyProducts: "দুগ্ধজাত পণ্য"
    },
    genoPerformance: {
      performanceOfGenoType: "জিনোটাইপের কর্মক্ষমতা",
      addAGenoType: "একটি জিনোটাইপ যোগ করুন",
      breedName: "জাতের নাম",
      chromosome: "ক্রোমোজোম",
      sequenceChange: "ক্রম পরিবর্তন",
      inheritance: "উত্তরাধিকার",
      diseaseName: "রোগের নাম",
      referenceSequence: "রেফারেন্স সিকোয়েন্স",
      pubmedReference: "প্রকাশ করা রেফারেন্স",
      genoTypeRegistration: "জিনোটাইপ নিবন্ধন",
      breed: "বংশবৃদ্ধি",
      editAGenoType: "একটি জিনোটাইপ সম্পাদনা করুন",
      editGenoType: "জিনোটাইপ সম্পাদনা করুন",
      loadingGene: "জেনো লোড হচ্ছে... অনুগ্রহ করে অপেক্ষা করুন",
      geneTypeList: "জিনোটাইপ তালিকা"
    },
    reportings: {
      conception: "ধারণা (ডেটা সায়েন্টিস্ট)",
      performanceOfGenoData: "জিনোটাইপের কর্মক্ষমতা (ডেটা সায়েন্টিস্ট)",
      totalInsemination: "টোটাল ইনসেমিনেশন",
      embryo: "ভ্রূণ",
      animalVaccinationRecord: "পশুর টিকা দেওয়ার রেকর্ড",
      dataNotAvailable: "এই খামারের জন্য ডেটা উপলব্ধ নয়।",
      pregnancyStatus: "গর্ভাবস্থার অবস্থা",
      healthReport: "স্বাস্থ্য রিপোর্ট",
      heavyMilk: "ভারী দুধ",
      standardMilk: "স্ট্যান্ডার্ড মিল্ক"
    },
    sidebar: {
      healthAnalytics: "স্বাস্থ্য বিশ্লেষণ",
      productionAnalytics: "উত্পাদন বিশ্লেষণ"
    },
    epd: {
      regNo: "অ্যানিমেল রেগ নং হল একটি অনন্য কোড যা প্রাণীকে চিহ্নিত করার একটি উপায় ব্যবহার করে, নির্দিষ্ট প্রাণীদের সনাক্তকরণ এবং ট্র্যাক করার প্রক্রিয়া নিশ্চিত করে।",
      internationalID: "প্রাণীর আন্তর্জাতিক আইডি",
      location: "প্রাণীর জন্মের দেশ / অঞ্চল ",
      animalName: "প্রমিত নাম / প্রাণীর নামকরণ",
      gender: "প্রাণীর লিঙ্গ (পুরুষ/মহিলা)",
      additionalIDMethod: "প্রাণী সনাক্ত করার জন্য কোন পদ্ধতি ব্যবহার করা হয়েছিল (যেমন কানের ট্যাগ, ট্যাটু)",
      damID: "পশুর বাঁধের আইডি বা নিবন্ধন নম্বর - একটি প্রাণীর মহিলা পিতা/মাতা/জৈবিক মায়ের সংখ্যার আইডি",
      sireId: "একটি পশুর পুরুষ পিতামাতার একটি আইডি বা নিবন্ধন নম্বর, বিশেষ করে প্রজননের জন্য রাখা ষাঁড় বা কৃত্রিম প্রজননের জন্য ব্যবহৃত ষাঁড়ের বীর্য।",
      dateOfBirth: "প্রাণীর জন্ম তারিখ।",
      breederHerdCode: "ব্রিডার হার্ড কোড বেশিরভাগ ব্রিডার অ্যাসোসিয়েশন দ্বারা প্রদত্ত",
      seasonofBirth: "প্রাণীর জন্মের ঋতু মাস অনুসারে উল্লেখ করা হয়েছে",
      birthYear: "যে বছর প্রাণীটির জন্ম হয়",
      birthManagementCode: "জন্ম ব্যবস্থাপনা কোড বেশিরভাগ ব্যবহারকারী/কৃষক দ্বারা প্রদত্ত",
      birthSex: "প্রাণীর লিঙ্গ (পুরুষ/মহিলা)",
      birthWeight: "বাছুরের জন্মের ওজন ",
      primaryBreed: "প্রাণীর প্রধান % জেনেটিক অবদান ",
      secondaryBreed: "প্রাণীর সামান্য % জেনেটিক অবদান ",
      breedComposition: "ব্রিড কম্পোজিশন শতাংশ বলতে একটি পৃথক প্রাণী বা প্রাণীদের একটি গোষ্ঠীর জেনেটিক মেকআপের মধ্যে বিভিন্ন প্রজাতির আনুপাতিক উপস্থাপনা বোঝায়। ",
      conceptionMethod: "কিভাবে প্রাণীটি গর্ভধারণ করা হয়েছিল (প্রাকৃতিক মিলন/গর্ভাধান/ভ্রূণ স্থানান্তর)।",
      accuracyWeight: "সঠিকতা ওজন",
      damAge: "মাস/বছরে বাঁধের বয়স যেমন ",
      weaningWeight: "দুধ ছাড়ানোর সময় পশুর ওজন।",
      weaningDate: "যে তারিখে পশুর দুধ ছাড়ানো হয়েছিল",
      weaningSex: "যে পশুর দুধ ছাড়ানো হয়েছিল তার লিঙ্গ। ",
      managementPastureCode: "ব্যবহারকারী/কৃষকের দ্বারা ব্যবস্থাপনা/চারণভূমিতে দেওয়া কোড ",
      creep: "ক্রিপ ফিডিং হল নার্সিং বাছুরকে সম্পূরক খাদ্য (শস্য বা চারা) প্রদানের অভ্যাস।",
      weaningContemporaryGroupCode: "ওয়েনিং ওজন সমসাময়িক গ্রুপ কোড",
      birthContemporaryCode: "জন্ম সমসাময়িক কোড",
      yearlingDate: "এক বছর বয়সী বা তার বয়সের দ্বিতীয় বছরে পশুর তারিখ",
      managementFeedUnitCode: "ব্যবহারকারীর দ্বারা ব্যবস্থাপনা/ফিড ইউনিটে দেওয়া কোড",
      yearlingSex: "বছর বয়সে পশুর লিঙ্গ ",
      yearlingWeight: "ইয়ারলিং ওয়েট হল দুধ ছাড়ানোর পর সরাসরি বৃদ্ধির একটি পরিমাপ এবং প্রায়ই বাছুরের পাউন্ডে পরিমাপ করা ফিডলটে বাজার-আবদ্ধ বংশধরের সম্ভাব্য কর্মক্ষমতা প্রতিফলিত করতে ব্যবহৃত হয়।",
      yearlingHeight: "বছর বয়সে প্রাণীর উচ্চতা ",
      yearlingWeightContemporaryGroupCode: "ইয়ারলিং ওজন সমসাময়িক গ্রুপ কোড",
      weaningYearlingWeightContemporaryGroupCode: "দুধ ছাড়ানোর কোড বা ইয়ারলিং ওয়েট কনটেম্পরারি গ্রুপ",
      daysOnFeed: "সেই নির্দিষ্ট ফিড দিয়ে খাওয়ানো দিনের সংখ্যা যেমন: অল্প বয়স্ক গবাদি পশুদের কম দামে বাজারজাতযোগ্য গরুর মাংস উৎপাদনের জন্য উচ্চ শক্তির খাদ্য খাওয়ানো হয়। ",
      managementFeedUnitPenCode: "ব্যবহারকারীর দ্বারা ব্যবস্থাপনা/ফিড ইউনিট/পেন দেওয়া কোড",
      harvestDate: "মাংসের জন্য পশু জবাই (হত্যা) করার তারিখ",
      gradingDate: "মৃতদেহের তারিখ একটি নির্দিষ্ট মানদণ্ড অনুসারে গ্রেড করা হয়েছিল",
      carcassSex: "মৃতদেহের লিঙ্গ",
      dateonFeed: "পশুটিকে নতুন খাদ্যে স্থানান্তরিত করার তারিখ যেমন: অল্প বয়সী গবাদি পশুদের কম লাভের মূল্যে বাজারজাতযোগ্য গরুর মাংস উৎপাদনের জন্য একটি উচ্চ শক্তির খাদ্য খাওয়ানো হয়। ",
      KPH: "% KPH হল মৃতদেহের গহ্বরে পাওয়া মোট চর্বির শতাংশ, বিশেষ করে কিডনি, পেলভিস এবং হার্টের অঞ্চলে। ",
      carcassWeight: "মৃতদেহের ওজন হল ফসল তোলার পর এবং চামড়া, মাথা, গ্যাস্ট্রোইনটেস্টাইনাল ট্র্যাক্ট এবং অভ্যন্তরীণ অঙ্গগুলি অপসারণের পরে গরম বা ঠাণ্ডা না করা ওজন। ",
      fatThickness: "চর্বি পুরুত্ব একটি ছোট শাসক ব্যবহার করে ইঞ্চি পরিমাপ করা হয়. ",
      marbling: "মার্বলিং হল দৃশ্যমান অসম্পৃক্ত (স্বাস্থ্যকর) ইন্ট্রামাসকুলার চর্বি যা পেশীর মধ্যে এবং পেশী ফাইবার বান্ডিলের মধ্যে জমা হয়।",
      ribeyeArea: "পাঁজর-চোখের পরিমাণ (কটি বা রিবেই পেশী লংসিসিমাস ডরসি) একটি গ্রিড ব্যবহার করে 12 তম এবং 13 তম পাঁজরের মধ্যে বর্গ ইঞ্চি পরিমাপ করা হয় (যেমন, 8, ​​9 বা 10 ইঞ্চি)। ",
      animalStatus:"খামারে পশুর অবস্থা যেমন: খামারে, বিক্রি, মারা যাওয়া ইত্যাদি"
    },
    manageAnimalGroupings: {
      resetModeTooltip: "\n        রিসেট মোড <br>\n            এই মোডে <br>\n            1) সমস্ত সমসাময়িক গোষ্ঠীর (CGs) বৈশিষ্ট্যগুলি সমস্ত আগ্রহের বৈশিষ্ট্যগুলির জন্য সেট/সংজ্ঞায়িত করুন। <br>\n            2) সমস্ত প্রাণীকে একটি সংশ্লিষ্ট সিজিতে বরাদ্দ করুন। <br>\n            3) প্রাণীদের বরাদ্দ সন্তোষজনক না হলে, সিজিগুলি সামঞ্জস্য করুন/পরিবর্তন করুন এবং তারপরে আবার প্রাণীদের নতুন সংশ্লিষ্ট সিজিগুলিতে বরাদ্দ করুন। <br>\n            4) প্রয়োজনে উপরের ধাপগুলি পুনরাবৃত্তি করুন, যতক্ষণ না আপনি CGs এবং প্রাণীদের সংশ্লিষ্ট গ্রুপিং/বরাদ্দকরণে সন্তুষ্ট না হন।<br>\n",
      maintainanceModeHeadingTooltip: "একবার রিসেট (মোড) চূড়ান্ত হয়ে গেলে, আপনি রক্ষণাবেক্ষণ মোডে প্রবেশ করবেন যেখানে রিসেটে গণনা করা EDPগুলি পরবর্তী রিসেট (যা 2-6 মাস দূরে হতে পারে) পর্যন্ত প্রতিটি প্রাণীর জন্য স্থির রাখা হবে। ",
      maintainanceModeTooltip: "রিসেট মোড সম্পূর্ণ করার পরে, সিস্টেমটিকে সমস্ত প্রাণীর EPD গণনা করতে, রিসেট মোড বন্ধ করতে এবং রক্ষণাবেক্ষণ মোড শুরু করতে সক্ষম করতে রিসেট চূড়ান্ত বোতাম টিপুন।",
      resetToggleTooltip: "CG-তে প্রাণী বরাদ্দ করতে EPD মডেল সেটিং-এ রিসেট টগল সক্ষম করুন।"
    },
    geneticsAndBreeding: {
      geneticsAndBreeding: "জেনেটিক্স",
      geneticSearchTool: "জেনেটিক সার্চ টুল",
      dataSubmission: "ডেটা জমা",
      animalsWithExpectedProgenyDifferences: "প্রত্যাশিত বংশগত পার্থক্য (EPDs) সহ প্রাণী",
      searchByAnimalIdName: "প্রাণী আইডি, নাম দ্বারা অনুসন্ধান করুন",
      rowsPerPage: "প্রতি পৃষ্ঠায় সারি",
      individualEntry: "স্বতন্ত্র এন্ট্রি",
      bulkEntry: "বাল্ক এন্ট্রি",
      registerANewAnimalOrSelectAnExistingAnimal: "একটি নতুন প্রাণী নিবন্ধন করুন বা একটি বিদ্যমান প্রাণী নির্বাচন করুন।",
      registerNewAnimal: "রেজিস্টার নতুন প্রাণী",
      selectExistingAnimal: "বিদ্যমান প্রাণী নির্বাচন করুন",
      animalID: "প্রাণী আইডি",
      animalName: "প্রাণীর নাম",
      tag: "ট্যাগ",
      dateOfBirth: "জন্ম তারিখ",
      gender: "লিঙ্গ",
      birthDate: "জন্ম তারিখ",
      birthWeightLb: "জন্মের ওজন (পাউন্ড)",
      birthWeightKg: "জন্মের ওজন (কেজি)",
      weaningWeightLb: "দুধ ছাড়ানোর ওজন (পাউন্ড)",
      weaningWeightKg: "দুধ ছাড়ানোর ওজন (কেজি)",
      yearlingWeightLb: "বার্ষিক ওজন (পাউন্ড)",
      yearlingWeightKg: "বার্ষিক ওজন (কেজি)",
      carcassWeightLb: "মৃতদেহের ওজন (পাউন্ড)",
      carcassWeightKg: "মৃতদেহের ওজন (কেজি)",
      animalSelection: "পশু নির্বাচন",
      animalSearchTool: "প্রাণী অনুসন্ধান টুল",
      back: "পেছনে",
      searchByEPDs: "EPDs দ্বারা অনুসন্ধান",
      searchByIds: "আইডি দ্বারা অনুসন্ধান করুন",
      selectBreed: "জাত নির্বাচন করুন",
      selectGender: "লিংগ নির্বাচন",
      selectRequiredBreedForCattle: "গবাদি পশুর জন্য প্রয়োজনীয় জাত নির্বাচন করুন",
      resetFilter: "ফিল্টার রিসেট করুন",
      birthWeightHeader: "জন্মের ওজন (BW): ",
      birthWeightDef: "জন্মের সময় বাছুরের ওজনের পার্থক্য তুলনা করে এবং পাউন্ড বা কেজিতে পরিমাপ করা হয়।",
      weaningWeightHeader: "দুধ ছাড়ানোর ওজন (WW): ",
      weaningWeightDef: "WW EPD হল প্রি-ওয়েনিং বৃদ্ধির একটি অনুমান যা পাউন্ড বা কেজিতে পরিমাপ করা হয়।",
      yearlingWeightHeader: "বার্ষিক ওজন (YW): ",
      yearlingWeightDef: "YW EPD হল দুধ ছাড়ানো পরবর্তী বৃদ্ধির একটি অনুমান যা পাউন্ড বা কেজিতে পরিমাপ করা হয়।",
      ribEyeAreaHeader: "Ribeye এলাকা (REA): ",
      ribEyeAreaDef: "REA পেশীর আকার পরিমাপ করে যা আমাদেরকে বর্গ ইঞ্চিতে ribeye দেয়। REA EPD গুলি কাটা গবাদি পশুর মৃতদেহ পরিমাপের উপর ভিত্তি করে একটি সামঞ্জস্যপূর্ণ 365-দিনের ribeye এলাকা পরিমাপের পার্থক্য প্রতিফলিত করে।",
      marblingHeader: "মার্বলিং(MARB): ",
      marblingDef: "MARB EPD হল ribeye-এর মধ্যে ইন্ট্রামাসকুলার ফ্যাটের শতাংশের এককে৷ MARB EPDগুলি কাটা গবাদি পশুর মৃতদেহের পরিমাপের উপর ভিত্তি করে একটি সামঞ্জস্যপূর্ণ 365-দিনের মার্বলিং স্কোরের (ইন্ট্রামাসকুলার ফ্যাট, [IMF]) পার্থক্যগুলি প্রতিফলিত করে৷",
      fatThicknessHeader: "চর্বি পুরুত্ব (FAT): ",
      fatThicknessDef: "ব্যাকফ্যাটের ইঞ্চি (এক ইঞ্চির শতভাগে) হল FT-এর পরিমাপের একক।",
      carcassWeightHeader: "মৃতদেহের ওজন (CW): ",
      carcassWeightDef: "শেষ পণ্যের মূল্যের তুলনায় পাউন্ডের প্রভাব বিবেচনা করার সময় মৃতদেহের ওজন একটি উপকারী বৈশিষ্ট্য। ",
      yieldGradeHeader: "ফলন গ্রেড(YG): ",
      yieldGradeDef: "USDA ইয়েলড গ্রেড স্কোরিং সিস্টেম হল YG EPD-এর পরিমাপের একক। ",
      milkHeader: "দুধ (MK): ",
      milkDef: "MK EPD তার মায়ের দুধ খাওয়ানোর ক্ষমতার কারণে বাছুরের দুধ ছাড়ানো ওজনের পাউন্ডে পরিমাপ করা হয়।",
      totalMaternalHeader: "মোট মাতৃত্ব (TM): ",
      totalMaternalDef: "TM দুধ উৎপাদন এবং বৃদ্ধির জন্য গরুর জেনেটিক্স উভয়ের কারণে বাছুরের দুধ ছাড়ানো ওজনের উপর প্রভাব পরিমাপ করে।",
      calvingEaseDirectHeader: "Calving Ease Direct(CED): ",
      calvingEaseDirectDef: "সিইডি ইপিডি অসহায় বাছুরের শতাংশ হিসাবে তালিকাভুক্ত।",
      calvingEaseMaternalHeader: "ক্যালভিং ইজ ম্যাটারনাল (CEM): ",
      calvingEaseMaternalDef: "একটি ষাঁড়ের কন্যাদের দুই বছর বয়সী হিসাবে অসহায় বাছুরের ক্ষমতা পরিমাপ করে।",
      stayabilityHeader: "স্থায়িত্ব (থাক): ",
      stayabilityDef: "ST EPD একটি ষাঁড়ের \"আশেপাশে থাকা\" গরুগুলিকে ডাকার ক্ষমতা ভবিষ্যদ্বাণী করে৷ ",
      docilityHeader: "আধিপত্য (DOC): ",
      docilityDef: "DOC গবাদি পশুর মেজাজ পরিমাপ করে।",
      max: "MAX",
      min: "MIN",
      accuracy: "সঠিকতা",
      sortBy: "ক্রমানুসার",
      traits: "ধূসর রঙে প্রদর্শিত বৈশিষ্ট্যগুলি বিকাশাধীন, Q2, 2023 এ আসছে।",
      searchResults: "অনুসন্ধান ফলাফল",
      recordsFound: "রেকর্ড পাওয়া গেছে",
      compareSelected: "নির্বাচন করা তুলনা",
      animalIdentification: "প্রাণী সনাক্তকরণ",
      errorMessage: {
        birthWeight: "জন্মের ওজন সর্বোচ্চ মান সর্বনিম্ন জন্ম ওজনের চেয়ে কম হতে পারে না",
        weaningWeight: "দুধ ছাড়ানো ওজনের সর্বোচ্চ মান ন্যূনতম ওজন ছাড়ার চেয়ে কম হতে পারে না",
        yearlingWeight: "বার্ষিক ওজন সর্বোচ্চ মান বার্ষিক ওজন সর্বনিম্ন থেকে কম হতে পারে না",
        carcassWeight: "মৃতদেহের ওজন সর্বোচ্চ মান জন্মের সর্বনিম্ন ওজনের চেয়ে কম হতে পারে না",
        fatThickness: "চর্বি পুরুত্ব সর্বাধিক মান স্তন্যপান ওজন সর্বনিম্ন থেকে কম হতে পারে না",
        marbling: "মার্বেল সর্বোচ্চ মান বার্ষিক ওজন সর্বনিম্ন কম হতে পারে না",
        ribeyeArea: "Ribeye এলাকা সর্বোচ্চ মান জন্ম ওজন সর্বনিম্ন থেকে কম হতে পারে না",
        yieldGrade: "ফলন গ্রেড সর্বাধিক মান স্তন্যদান ওজন সর্বনিম্ন থেকে কম হতে পারে না",
        milk: "দুধের সর্বোচ্চ মান দুধ ছাড়ানোর ওজন ন্যূনতম থেকে কম হতে পারে না"
      },
      reg: "রেজি",
      name: "নাম",
      sex: "সেক্স",
      tattoo: "ট্যাটু",
      dob: "ডিওবি",
      EPD: "ইপিডি",
      rank: "পদমর্যাদা",
      searchValue: "অনুসন্ধান মান",
      typeHere: "এখানে লিখুন",
      searching: "অনুসন্ধান করা হচ্ছে...",
      fetchingResult: "ফলাফল আনা হচ্ছে...অনুগ্রহ করে অপেক্ষা করুন",
      animalsMatchedYourCriteria: "প্রাণী আপনার মানদণ্ড মিলেছে",
      manageAnimalsGrouping: "প্রাণীদের গ্রুপিং পরিচালনা করুন",
      manageAnimalGroupings: "পশু গ্রুপিং পরিচালনা করুন",
      assignAnimalToContemporaryGroups: "সমসাময়িক গোষ্ঠীতে প্রাণী বরাদ্দ করুন",
      resetMode: "রিসেট মোড",
      enterResetMode: "রিসেট মোডে প্রবেশ করুন",
      maintainanceMode: "রক্ষণাবেক্ষণ মোড",
      assigningAnimals: "প্রাণী বরাদ্দ",
      excludedAnimals: "বর্জিত প্রাণী",
      ungroupedAnimals: "গোষ্ঠীবিহীন প্রাণী",
      assignAnimalsToCGS: "CGS-এ প্রাণী বরাদ্দ করুন",
      reset: "রিসেট",
      excludeAnimals: "প্রাণীদের বাদ দিন",
      resetToMaintainanceMode: "রিসেট চূড়ান্ত - রক্ষণাবেক্ষণ মোডে পরিবর্তন করুন",
      contemporaryGroupsSettings: "সমসাময়িক গ্রুপ (সিজি) সেটিংস",
      selectTrait: "বৈশিষ্ট্য নির্বাচন করুন",
      selectTraitDescription:"বৈশিষ্ট্য নির্বাচন একটি নির্দিষ্ট বৈশিষ্ট্য নির্বাচন করার প্রক্রিয়া বোঝায়",
      traitsType: {
        birthWeight: "জন্মের ওজন",
        weaningWeight: "দুধ ছাড়ানো ওজন",
        yearlingWeight: "বার্ষিক ওজন",
        carcassWeight: "মৃতদেহের ওজন"
      },
      addNewGroup: "নতুন গ্রুপ যোগ করুন",
      contemporaryGroup: "সমসাময়িক গ্রুপ",
      contemporaryGroups: "সমসাময়িক গ্রুপ",
      editGroup: "গ্রুপ সম্পাদনা করুন",
      birthCGCode: "জন্ম (CG) কোড",
      groupName: "দলের নাম",
      birthSex: "জন্ম সেক্স",
      conceptionMethod: "ধারণা পদ্ধতি",
      weaningCGCode: "দুধ ছাড়ানোর (CG) কোড",
      yearlingCGCode: "বার্ষিক (সিজি) কোড",
      dateWeight: "তারিখ ওজন",
      weaningyearlingCGcode: "দুধ ছাড়ানো/বার্ষিক (সিজি) কোড",
      carcassCGCode: "শব(CG) কোড",
      breedOfDom: "বাঁধের জাত",
      addNewContemporaryGroup: "নতুন সমসাময়িক গ্রুপ যোগ করুন",
      createNewGroup: "নতুন গ্রুপ তৈরি করুন",
      selectFromDifferentTraits: "বিভিন্ন বৈশিষ্ট্য থেকে নির্বাচন করুন",
      contemporaryGroupName: "সমসাময়িক গ্রুপের নাম",
      enterNameHere: "এখানে নাম লিখুন",
      groupNameIsRequired: "গ্রুপ নাম প্রয়োজন",
      birthYearRange: "জন্ম বছরের পরিসর",
      theYearAnimalWasBorn: "যে বছর প্রাণীর জন্ম হয়েছিল",
      birthYearIsRequired: "জন্ম বছর প্রয়োজন",
      genderOfNewBornAnimal: "নবজাত প্রাণীর লিঙ্গ",
      selectSex: "সেক্স নির্বাচন করুন",
      theweightOfAnimalAtBirth: "জন্মের সময় পশুর ওজন",
      maximumKg: "সর্বোচ্চ",
      minimumKg: "সর্বনিম্ন",
      aSeasonisAPeriodOfYear: "একটি ঋতু বছরের একটি সময়কাল যা বিশেষ জলবায়ু অবস্থার দ্বারা পৃথক করা হয়।",
      seasonofBirthIsRequired: "জন্মের ঋতু প্রয়োজন",
      majorGenericContributionOfAnimal: "প্রধান % প্রাণীর সাধারণ অবদান",
      primaryBreedCompostionIsRequired: "প্রাথমিক জাতের কম্পোশন প্রয়োজন",
      secondaryBreedCompostionIsRequired: "সেকেন্ডারি ব্রিড কম্পোশন প্রয়োজন",
      howTheAnimalWasConceived: "কিভাবে প্রাণীটি গর্ভধারণ করা হয়েছিল (প্রাকৃতিক মিলন/প্রজনন/ভ্রূণ স্থানান্তর)",
      conceptionMethodIsRequired: "ধারণা পদ্ধতি প্রয়োজন",
      epdModelSettings: "EPD মডেল সেটিংস",
      forResetMode: "রিসেট মোডের জন্য",
      progenyWeightingFactor: "বংশধর ওজন ফ্যাক্টর",
      weightGivenToTheProgenyFactor: "রিসেট মোডে EPD গণনার জন্য CG ফ্যাক্টরের সাপেক্ষে বংশজাত ফ্যাক্টরকে দেওয়া ওজন। ",
      enterNumber: "সংখ্যা প্রবেশ করান",
      enterBreed: "ব্রিড এন্টার করুন",
      valueShouldBeBetween0and1: "মান 0 এবং 1 এর মধ্যে হওয়া উচিত",
      resetDuration: "সময়কাল রিসেট করুন",
      timeIntervalBetweenLastAndFirstResetMode: "শেষ এবং নতুন রিসেট মোডের মধ্যে সময়ের ব্যবধান, যার শেষে নতুন রিসেট মোড সক্রিয় করা হয় এবং নতুন CGs এবং EPD গণনা করা হয়।",
      enterNumberOfDays: "দিনের সংখ্যা লিখুন",
      valueCannotBeNegative: "মান নেতিবাচক হতে পারে না!",
      criticalProgenyPopulation: "ক্রিটিক্যাল প্রোজেনি পপুলেশন",
      minimumNumberOfProgenyRecords: "50% এর উপরে (বংশীয় নির্ভুলতার জন্য) প্রোজেনি অ্যাকুরেসি (APD1) অর্জনের জন্য সিস্টেমে পৃথক প্রাণীর বংশধর রেকর্ডের ন্যূনতম সংখ্যা",
      criticalAncestorPopulation: "সমালোচনামূলক পূর্বপুরুষ জনসংখ্যা",
      minimumNumberOfAncestorsRecords: "পূর্বপুরুষ নির্ভুলতা (APD4) অর্জনের জন্য সিস্টেমে পৃথক প্রাণীর ন্যূনতম সংখ্যক পূর্বপুরুষের রেকর্ড 50% এর উপরে (বংশের সঠিকতার জন্য)",
      forBirthWeightCG: "জন্ম ওজন CG জন্য",
      criticalPopulationInAnimalsContemporaryGroup: "প্রাণীর সমসাময়িক গোষ্ঠীতে সমালোচনামূলক জনসংখ্যা",
      minimumAverageNumberOfAnimalsPerBirthWeight: "50% এর উপরে গড় CG নির্ভুলতা (ACG3) অর্জনের জন্য জন্মের ওজন CG প্রতি পশুর ন্যূনতম গড় সংখ্যা",
      criticalAveragePopulationPerContemporaryGroup: "সমসাময়িক গ্রুপ প্রতি সমালোচনামূলক গড় জনসংখ্যা",
      minimumNumberOfAnimalsInBirthWeight: "50% এর উপরে CG নির্ভুলতা (ACG2) অর্জনের জন্য পশুর জন্মের ওজন CG এর ন্যূনতম সংখ্যা",
      forWeaningWeightCG: "ওজন কমানোর জন্য CG",
      minimumAverageNumberOfAnimalsPerWeaningWeight: "50% এর উপরে গড় CG নির্ভুলতা (ACG3) অর্জনের জন্য প্রয়োজন প্রতি দুধ ছাড়ানোর ওজন CG প্রতি পশুর ন্যূনতম গড় সংখ্যা",
      minimumNumberOfAnimalsInWeaningWeight: "50% এর উপরে CG নির্ভুলতা (ACG2) অর্জনের জন্য পশুর দুধ ছাড়ানোর ওজন CG-তে পশুর ন্যূনতম সংখ্যা",
      forYearlingWeightCG: "ইয়ারলিং ওয়েট সিজির জন্য",
      minimumAverageNumberOfAnimalsPerYearling: "50% এর উপরে গড় CG নির্ভুলতা (ACG3) অর্জনের জন্য বার্ষিক CG প্রতি ন্যূনতম গড় সংখ্যা",
      minimumNumberOfAnimalsInYearlingWeight: "50% এর উপরে CG সঠিকতা (ACG2) অর্জনের জন্য পশুর বার্ষিক ওজন সিজিতে পশুর ন্যূনতম সংখ্যা",
      forCarcassCG: "শব CG জন্য",
      minimumAverageNumberOfAnimalsPerCarcassWeight: "50% এর উপরে গড় CG নির্ভুলতা (ACG3) অর্জনের জন্য শবের ওজন CG প্রতি পশুর ন্যূনতম গড় সংখ্যা",
      minimumNumberOFAnimalInCarcassWeight: "50% এর উপরে CG নির্ভুলতা (ACG2) অর্জনের জন্য পশুর মৃতদেহের ওজন CG-তে পশুর ন্যূনতম সংখ্যা",
      epdRequiredFieldSettings: "EPD প্রয়োজনীয় ক্ষেত্র সেটিংস",
      pleaseSelectRequiredFieldsForCompleteEPD: "একটি সম্পূর্ণ EPD গণনার জন্য প্রয়োজনীয় ক্ষেত্র নির্বাচন করুন",
      byDefault: "গতানুগতিক",
      pleaseNoteThatUsersNotAbleToObtainFullEPD: "দ্রষ্টব্য: দয়া করে মনে রাখবেন যে ব্যবহারকারীরা সম্পূর্ণ EPD গণনা পেতে সক্ষম হবে না যদি তারা আপনার প্রয়োজনীয় হিসাবে চিহ্নিত করা ডেটা ক্ষেত্রগুলি সরবরাহ না করে।",
      pleaseNoteThatRequiredFieldParametersCannotBeChanged: "দ্রষ্টব্য: অনুগ্রহ করে মনে রাখবেন প্রয়োজনীয় ক্ষেত্রের পরামিতি পরিবর্তন করা যাবে না যেহেতু পূর্ববর্তী প্যারামিটারগুলির বিপরীতে ইতিমধ্যে সমসাময়িক গোষ্ঠী রয়েছে৷",
      noResultFound: "কোন ফলাফল পাওয়া যায়নি",
      next: "পরবর্তী",
      cancel: "বাতিল করুন",
      selectAnimal: "প্রাণী নির্বাচন করুন",
      searchBy: "দ্বারা অনুসন্ধান",
      breed: "বংশবৃদ্ধি",
      regDate: "রেজি. ",
      status: "স্ট্যাটাস",
      animalDetails: "প্রাণীর বিবরণ",
      add: "যোগ করুন",
      update: "হালনাগাদ",
      dataForEPDs: " EPD-এর জন্য ডেটা",
      basicInformation: "মৌলিক তথ্য",
      birthWeightInformation: "জন্ম ওজন তথ্য",
      weaningWeightInformation: "দুধ ছাড়ানো ওজন তথ্য",
      yearlingWeightInformation: "বার্ষিক ওজন তথ্য",
      carcassWeightInformation: "শব ওজন তথ্য",
      delete: "মুছে ফেলা",
      deleteEpdData: "EPD ডেটা মুছুন",
      areYouSureYouWantToDeleteEpdData: "আপনি কি নিশ্চিত যে আপনি EPD ডেটা মুছতে চান৷",
      internationalID: "আন্তর্জাতিক আইডি",
      enterID: "আইডি লিখুন",
      animalRegistration: "পশু নিবন্ধন",
      location: "অবস্থান",
      additionalIDMethod: "অতিরিক্ত আইডি পদ্ধতি",
      damID: "ড্যাম আইডি",
      sireID: "স্যার আইডি",
      breederHerdCode: "ব্রিডার হার্ড কোড",
      birthYear: "জন্ম সাল",
      primaryBreed: "প্রাথমিক জাত",
      breedComposition: "জাত রচনা",
      secondaryBreed: "মাধ্যমিক জাত",
      seasonofBirth: "জন্মের ঋতু",
      birthManagementCode: "জন্ম ব্যবস্থাপনা কোড",
      damAge: "বাঁধ বয়স",
      years: "বছর",
      birthContemporaryCode: "জন্ম সমসাময়িক কোড",
      accuracyWeight: "সঠিকতা ওজন",
      note: "বিঃদ্রঃ",
      minimumRequiredFieldForBirthWeight: "জন্মের ওজন EPD-এর জন্য ন্যূনতম প্রয়োজনীয় ক্ষেত্র",
      birthYearGenderConceptionMethodBirthWeight: "জন্ম সাল, লিঙ্গ, গর্ভধারণের পদ্ধতি, জন্মের ওজন",
      weaningWeight: "দুধ ছাড়ানো ওজন",
      weaningDate: "দুধ ছাড়ানোর তারিখ",
      weaningContemporaryGroupCode: "সমসাময়িক গ্রুপ কোড ছাড়ান",
      creep: "হামাগুড়ি",
      managementPastureCode: "ব্যবস্থাপনা/চারণ কোড",
      weaningSex: "দুধ ছাড়ানো সেক্স",
      minimumRequiredFieldForWeaningWeight: "ওয়েনিং ওয়েট EPD-এর জন্য ন্যূনতম প্রয়োজনীয় ক্ষেত্র",
      weaningWeightManagementPastureCodeWeaningSexDateWeighed: "ওয়েনিং ওয়েট , ম্যানেজমেন্ট/পাসচার কোড , ওয়েনিং সেক্স , তারিখ ওজন",
      yearlingWeight: "বার্ষিক ওজন",
      yearlingHeight: "বার্ষিক উচ্চতা",
      yearlingDate: "বার্ষিক তারিখ",
      yearlingContemporaryGroupCode: "বার্ষিক সমসাময়িক গ্রুপ কোড",
      managementFeedingCode: "ম্যানেজমেন্ট/ফিডিং কোড",
      yearlingSex: "ইয়ারলিং সেক্স",
      youWillNeedToFillOutFor: "EPD ডেটা পুনরুদ্ধার করতে আপনাকে সমস্ত ক্ষেত্র পূরণ করতে হবে",
      pleaseSelectHavestDateFirstToEnterInfo: "রিব আই এরিয়া, ফ্যাট থিকনেস এবং মার্বলিংয়ের তথ্য লিখতে অনুগ্রহ করে প্রথমে 'হার্ভেস্ট ডেট' নির্বাচন করুন",
      harvestDate: "ফসল কাটার তারিখ",
      dateOnFeed: "ফিড উপর তারিখ",
      daysOnFeed: "ফিড উপর দিন",
      gradingDate: "গ্রেডিং তারিখ",
      carcassSex: "শব সেক্স",
      carcassWeight: "মৃতদেহের ওজন",
      carcassContemporary: "শব সমসাময়িক",
      damBreed: "বাঁধ জাত",
      ribEyeArea: "রিব আই এরিয়া",
      ribEyeAreaContemporary: "রিব আই এরিয়া সমসাময়িক",
      fatThickness: "চর্বি পুরুত্ব",
      fatThicknessContemporary: "চর্বি পুরুত্ব সমসাময়িক",
      marbling: "মার্বলিং",
      marblingContemporary: "মার্বেল সমসাময়িক",
      yieldGradeContemporary: "ফলন গ্রেড সমসাময়িক",
      animalsNotListedInContemporaryGroupsMsg: "অনুপস্থিত তথ্যের কারণে কোনো সমসাময়িক গোষ্ঠীতে প্রাণীদের যোগ করা হয়নি। ",
      listOfUngroupedAnimals: "গ্রুপবিহীন প্রাণীদের তালিকা",
      submittingData: "ডেটা জমা দেওয়া হচ্ছে",
      resendToUser: "ব্যবহারকারীকে পুনরায় পাঠান",
      submittingAnimalsInGroupMsg: "দলে আপনার পশু জমা. ",
      pressingResetBtnMsg: "\"রিসেট\" বোতাম টিপলে প্রাণীদের তাদের সমসাময়িক গোষ্ঠীতে পুনরায় বরাদ্দ করার একটি প্রক্রিয়া শুরু হবে।",
      doYouWantToProceed: "আপনি কি এগিয়ে যেতে চান ?",
      systemMaintainanceModeMsg: "\"রক্ষণাবেক্ষণ মোডে পরিবর্তন করুন\" বোতাম টিপলে একটি প্রক্রিয়া শুরু হবে এবং আপনার সিস্টেমটি \"রক্ষণাবেক্ষণ মোডে\" প্রবেশ করবে যেখানে রিসেটে গণনা করা ইডিপিগুলি পরবর্তী রিসেট পর্যন্ত প্রতিটি প্রাণীর জন্য স্থির রাখা হবে (যা 1-6 মাস হতে পারে। ",
      errorFetchingContemporaryGrpMsg: "সমসাময়িক গোষ্ঠী ডেটা আনার সময় ত্রুটি৷",
      deleteSuccess: "সফলতা মুছুন",
      deleteSuccessMsg: "সমসাময়িক গ্রুপ সফলভাবে মুছে ফেলা হয়েছে.",
      deleteFailed: "মুছে ফেলতে ব্যর্থ হয়েছে",
      deleteFailedMsg: "সমসাময়িক গোষ্ঠী ডেটা মুছে ফেলার সময় ত্রুটি৷",
      deleteContemporaryGrpMsg: "আপনি কি এই সমসাময়িক গ্রুপটি মুছে ফেলার বিষয়ে নিশ্চিত?",
      addBirthWeightData: "জন্ম ওজন ডেটা যোগ করুন",
      addWeaningWeightData: "ওয়েনিং ওয়েট ডেটা যোগ করুন",
      birthWeightContemporaryGroupCode: "জন্ম ওজন সমসাময়িক গ্রুপ কোড",
      dateWeighted: "তারিখ ওজন করা হয়েছে",
      addYearlingWeightData: "বার্ষিক ওজন ডেটা যোগ করুন",
      addCarcassWeightData: "মৃতদেহের ওজনের ডেটা যোগ করুন",
      weaningOrYearlingContemporaryGroupCode: "দুধ ছাড়ানো বা ইয়ারলিং ওজন সমসাময়িক গ্রুপ কোড",
      deleteContemporaryGroupMsg: "আপনি সমসাময়িক গ্রুপ মুছে ফেলার বিষয়ে নিশ্চিত?",
      updateSuccessMsg: "সমসাময়িক গ্রুপ সফলভাবে আপডেট করা হয়েছে।",
      errorMsg: "কিছু ভুল হয়েছে. ",
      fetchErrorMsg: "নির্বাচিত বৈশিষ্ট্যের জন্য প্রয়োজনীয় ক্ষেত্রগুলি আনতে ত্রুটি৷",
      forMaintainanceMode: "রক্ষণাবেক্ষণ মোডের জন্য",
      ancestorsWeightFactor: "পূর্বপুরুষের ওজন ফ্যাক্টর",
      weightGivenToTheAncestorFactor: "রক্ষণাবেক্ষণ মোডে EPD গণনার জন্য CG ফ্যাক্টরের সাপেক্ষে পূর্বপুরুষ ফ্যাক্টরকে দেওয়া ওজন। ",
      addEPDModelSettingsData: "EPD মডেল সেটিংস ডেটা যোগ করুন",
      minimumNumberOfAnimalsInContemporaryGroups: "সমসাময়িক গোষ্ঠীতে পশুর ন্যূনতম সংখ্যা",
      enterNumberOfAnimals: "প্রাণীর সংখ্যা লিখুন",
      areYouSureYouWantToChangeEPDCalculation: "আপনি কি প্রয়োজনীয় EPD গণনার ক্ষেত্র পরিবর্তন করার বিষয়ে নিশ্চিত?",
      weightOfAnimalAtBirth: "জন্মের সময় পশুর ওজন",
      seasonIsAPeriodOfYear: "একটি ঋতু বছরের একটি সময়কাল যা বিশেষ জলবায়ু অবস্থার দ্বারা পৃথক করা হয়।",
      codeOfBirthWeightContemporaryGroup: "জন্ম ওজন সমসাময়িক গ্রুপ কোড",
      weaningWeightOfCalf: "বাছুরের দুধ ছাড়ানো ওজন",
      dateAnimalWasWeaned: "পশুর দুধ ছাড়ানোর তারিখ",
      genderOfWeaningAnimal: "দুধ ছাড়ানো প্রাণীর লিঙ্গ",
      yearlingWeightOfCalf: "বাছুরের বার্ষিক ওজন",
      dateAnimalWasWeighted: "যে তারিখে পশুটির ওজন করা হয়েছিল",
      yearledAnimalSex: "পশুর লিঙ্গ যে বছর বয়সী ছিল",
      dateOfAnimalKilledForMeat: "মাংসের জন্য পশু হত্যার তারিখ",
      addSuccessMsg: "সমসাময়িক গ্রুপ সফলভাবে যোগ করা হয়েছে",
      traitH: "EPD গণনার বৈশিষ্ট্য।",
      searchByValue: "রেজিস্ট্রেশন নম্বর/ট্যাটু/নাম/ট্যাগ লিখুন"
    }
  }